var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277.013,
    height: 176.186,
    viewBox: "0 0 277.013 176.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_",
    "data-name": "Illustration ",
    transform: "translate(-23.809 -34.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-13",
    transform: "translate(23.808 34.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510716",
    "data-name": "Path 510716",
    d: "M77.55,380.031A9.236,9.236,0,0,1,80,373.94C80.743,377,77.55,380.031,77.55,380.031Z",
    transform: "translate(-56.071 -238.128)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510717",
    "data-name": "Path 510717",
    d: "M86.46,383.82a9.193,9.193,0,0,1,6.563-.18C90.517,385.538,86.46,383.82,86.46,383.82Z",
    transform: "translate(-61.42 -243.639)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510718",
    "data-name": "Path 510718",
    d: "M87.272,372.254a7.274,7.274,0,0,1,.9-5.1C89.243,369.388,87.272,372.254,87.272,372.254Z",
    transform: "translate(-61.829 -234.051)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510719",
    "data-name": "Path 510719",
    d: "M53,362a14.784,14.784,0,0,1,7.993,5.907C56.561,367.927,53,362,53,362Z",
    transform: "translate(-41.333 -230.96)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510720",
    "data-name": "Path 510720",
    d: "M73.815,349.414c-.272-5.6,5.2-11.954,5.2-11.954a24.441,24.441,0,0,1-5.2,11.954",
    transform: "translate(-53.823 -216.228)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510721",
    "data-name": "Path 510721",
    d: "M70.593,327.41a15.036,15.036,0,0,1-1.97,8.033C67.847,331.834,70.593,327.41,70.593,327.41Z",
    transform: "translate(-50.629 -210.194)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510722",
    "data-name": "Path 510722",
    d: "M58.961,349.13c-4.1-.44-6.331-4.52-6.331-4.52C57.574,346,58.961,349.13,58.961,349.13Z",
    transform: "translate(-41.111 -220.52)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510723",
    "data-name": "Path 510723",
    d: "M46.34,396.75a9.22,9.22,0,0,1,6.447-1.239C50.62,397.789,46.34,396.75,46.34,396.75Z",
    transform: "translate(-37.335 -250.993)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510724",
    "data-name": "Path 510724",
    d: "M68.77,403.43A6.055,6.055,0,0,1,66,406.535C66.188,404.641,68.77,403.43,68.77,403.43Z",
    transform: "translate(-49.137 -255.831)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510725",
    "data-name": "Path 510725",
    d: "M64.244,401.651a7.286,7.286,0,0,1-4.9.875C60.919,400.884,64.244,401.651,64.244,401.651Z",
    transform: "translate(-45.139 -254.656)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510726",
    "data-name": "Path 510726",
    d: "M70.084,373.018v-2.77c0-.58,0-1.239-.04-1.97-.036-1.455-.14-3.2-.288-5.112s-.4-4.029-.719-6.231c-.651-4.4-1.535-8.341-2.246-11.171-.36-1.415-.663-2.558-.883-3.341l-.268-.9-.06-.24v-.08a.173.173,0,0,0,.032.076,1.574,1.574,0,0,1,.076.232l.276.9c.244.779.568,1.918.939,3.329a102.622,102.622,0,0,1,2.3,11.191c.324,2.206.552,4.32.707,6.243s.232,3.661.232,5.128v3.457c0,.408-.028.711-.036.939v.244A.232.232,0,0,1,70.084,373.018Z",
    transform: "translate(-48.885 -218.473)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510727",
    "data-name": "Path 510727",
    d: "M58,391.1c.028-.04,1.687,1.047,3.7,2.426s3.629,2.538,3.6,2.582-1.675-1.051-3.7-2.43S58,391.142,58,391.1Z",
    transform: "translate(-44.335 -248.428)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510728",
    "data-name": "Path 510728",
    d: "M76.29,382.755a1.517,1.517,0,0,1,.252-.28l.739-.711,2.466-2.31,2.462-2.31.759-.7a1.556,1.556,0,0,1,.292-.24,1.556,1.556,0,0,1-.24.292c-.16.18-.4.432-.707.743-.607.62-1.463,1.451-2.43,2.354s-1.85,1.7-2.5,2.274c-.324.284-.592.512-.779.667A1.6,1.6,0,0,1,76.29,382.755Z",
    transform: "translate(-55.315 -239.484)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510729",
    "data-name": "Path 510729",
    d: "M44.85,384.45s4.237-.08,6.031,3.257A7.626,7.626,0,0,1,44.85,384.45Z",
    transform: "translate(-36.44 -244.437)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510730",
    "data-name": "Path 510730",
    d: "M59.325,380.2s3.449,2.462,2.9,6.207a7.63,7.63,0,0,1-2.9-6.207Z",
    transform: "translate(-45.128 -241.886)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510731",
    "data-name": "Path 510731",
    d: "M96.267,365s-1.363,4.744-5.687,5.6a8.885,8.885,0,0,1,5.687-5.6Z",
    transform: "translate(-63.893 -232.761)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510732",
    "data-name": "Path 510732",
    d: "M54.62,320.9s5.408,3.525,4.8,9.26a11.618,11.618,0,0,1-4.8-9.26Z",
    transform: "translate(-42.306 -206.286)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510733",
    "data-name": "Path 510733",
    d: "M88.3,399.39a2.122,2.122,0,0,1-.352.28c-.236.172-.568.424-.971.743a24.5,24.5,0,0,0-2.934,2.75,24.127,24.127,0,0,0-2.422,3.2c-.276.436-.492.8-.635,1.047a2.2,2.2,0,0,1-.24.376,2.1,2.1,0,0,1,.176-.4c.124-.26.324-.631.588-1.079a21.15,21.15,0,0,1,2.4-3.261,20.881,20.881,0,0,1,2.986-2.73,10.808,10.808,0,0,1,1.011-.7,1.826,1.826,0,0,1,.4-.228Z",
    transform: "translate(-57.992 -253.406)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510734",
    "data-name": "Path 510734",
    d: "M87.665,398.517a9.232,9.232,0,0,1,1.251-6.447A9.114,9.114,0,0,1,87.665,398.517Z",
    transform: "translate(-62.062 -249.012)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510735",
    "data-name": "Path 510735",
    d: "M97,401.92a6.715,6.715,0,0,1,4.72-.731A6.619,6.619,0,0,1,97,401.92Z",
    transform: "translate(-67.747 -254.397)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510736",
    "data-name": "Path 510736",
    d: "M57.13,421.92l2.026,13.329H70.943l2.738-13.137Z",
    transform: "translate(-43.812 -266.931)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510737",
    "data-name": "Path 510737",
    d: "M74.149,443.188c0,.04-3.018.072-6.742.072s-6.746-.032-6.746-.072,3.022-.068,6.746-.068S74.149,443.152,74.149,443.188Z",
    transform: "translate(-45.932 -279.658)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510738",
    "data-name": "Path 510738",
    d: "M74.119,441.548c0,.04-3.041.072-6.794.072s-6.794-.032-6.794-.072,3.038-.068,6.794-.068S74.119,441.512,74.119,441.548Z",
    transform: "translate(-45.853 -278.674)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510739",
    "data-name": "Path 510739",
    d: "M74.059,439.7c0,.04-3.041.068-6.794.068s-6.794-.028-6.794-.068,3.042-.068,6.794-.068S74.059,439.658,74.059,439.7Z",
    transform: "translate(-45.817 -277.563)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510740",
    "data-name": "Path 510740",
    d: "M64.708,448.291a21.982,21.982,0,0,1-.588-3.381,10.391,10.391,0,0,1,.364,1.679,10.52,10.52,0,0,1,.224,1.7Z",
    transform: "translate(-48.009 -280.733)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510741",
    "data-name": "Path 510741",
    d: "M67.264,448.077q-.184-1.633-.224-3.277a12.994,12.994,0,0,1,.224,3.277Z",
    transform: "translate(-49.762 -280.667)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510742",
    "data-name": "Path 510742",
    d: "M70.649,447.921a13.645,13.645,0,0,1-.4-3.381,14.882,14.882,0,0,1,.228,1.687A14.388,14.388,0,0,1,70.649,447.921Z",
    transform: "translate(-51.688 -280.511)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510743",
    "data-name": "Path 510743",
    d: "M73.542,448.051a8.581,8.581,0,0,1-.164-1.707,8.445,8.445,0,0,1,.052-1.715,14.389,14.389,0,0,1,.088,1.711A14.786,14.786,0,0,1,73.542,448.051Z",
    transform: "translate(-53.553 -280.565)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510744",
    "data-name": "Path 510744",
    d: "M78.122,448.131A10.044,10.044,0,0,1,78,446.513a9.5,9.5,0,0,1,0-1.623,10.1,10.1,0,0,1,.14,1.643A9.5,9.5,0,0,1,78.122,448.131Z",
    transform: "translate(-56.319 -280.721)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510745",
    "data-name": "Path 510745",
    d: "M81.578,448.159a10.391,10.391,0,0,1-.056-1.675,9.936,9.936,0,0,1,.084-1.675A20.083,20.083,0,0,1,81.578,448.159Z",
    transform: "translate(-58.449 -280.673)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510746",
    "data-name": "Path 510746",
    d: "M84.79,447.505a23.113,23.113,0,0,1,.34-3.485,11.057,11.057,0,0,1-.1,1.751,10.484,10.484,0,0,1-.24,1.735Z",
    transform: "translate(-60.417 -280.199)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510747",
    "data-name": "Path 510747",
    d: "M88.81,447.922A9.02,9.02,0,0,1,89.445,445a13.476,13.476,0,0,1-.3,1.467A14.574,14.574,0,0,1,88.81,447.922Z",
    transform: "translate(-62.831 -280.787)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510748",
    "data-name": "Path 510748",
    d: "M53.74,415.3V417.8a.983.983,0,0,0,.983.979H71.789a.983.983,0,0,0,.983-.983V415.3Z",
    transform: "translate(-41.777 -262.957)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510749",
    "data-name": "Path 510749",
    d: "M57.45,424.01l.14.8,15.747,1.119.4-1.914Z",
    transform: "translate(-44.004 -268.186)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510750",
    "data-name": "Path 510750",
    d: "M160.235,41.05,159.4,63.983l5.639,2.562,1.247,3.233,10.108-4.113L175.011,62.4l1.93-6.019Z",
    transform: "translate(-105.208 -38.284)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510751",
    "data-name": "Path 510751",
    d: "M160.151,41.05l16.754,15.283.032.032v.04l-1.926,6.023v-.052c.44,1.031.907,2.138,1.387,3.257l.028.072-.072.028-5.156,2.1-4.948,2-.076.028-.028-.072L164.9,66.557l.04.04L159.3,64.031h-.044v-.048c.532-13.425.883-22.294.907-22.929-.02.635-.316,9.5-.763,22.933l-.04-.064L165,66.481h.028v.032c.4,1.059.827,2.134,1.247,3.229l-.1-.044,4.948-2,5.156-2.1-.04.1c-.476-1.123-.943-2.23-1.383-3.261v-.052c.675-2.09,1.323-4.1,1.938-6.019v.076Z",
    transform: "translate(-105.124 -38.284)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510752",
    "data-name": "Path 510752",
    d: "M176.747,73.5a3.273,3.273,0,0,1-1.8,4.312,3.393,3.393,0,0,1-4.4-1.795,3.277,3.277,0,0,1,1.8-4.316A3.393,3.393,0,0,1,176.747,73.5Z",
    transform: "translate(-111.748 -56.534)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510753",
    "data-name": "Path 510753",
    d: "M161.489,41.05c.04,0,1.6,3.429,3.509,7.7s3.405,7.742,3.365,7.762-1.6-3.429-3.509-7.7S161.449,41.066,161.489,41.05Z",
    transform: "translate(-106.461 -38.284)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510754",
    "data-name": "Path 510754",
    d: "M211.277,173.345h0a5.4,5.4,0,0,1-6.99-2.834L180.51,115.357l9.864-4,23.748,55.1a5.2,5.2,0,0,1-2.846,6.882Z",
    transform: "translate(-117.881 -80.493)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510755",
    "data-name": "Path 510755",
    d: "M187.609,104.371l-11.6,4.72-1.691-3.981,11.6-4.72Z",
    transform: "translate(-114.165 -73.908)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510756",
    "data-name": "Path 510756",
    d: "M179.757,322.37l-6.027,21.846,7.386,5.268,16.614,4.045,6.587-24.664Z",
    transform: "translate(-113.811 -207.169)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510757",
    "data-name": "Path 510757",
    d: "M176.957,374.58l-3.2.979a9.716,9.716,0,0,0,2.594,3.022,14.139,14.139,0,0,0,4.8,2.246A9.419,9.419,0,0,1,176.957,374.58Z",
    transform: "translate(-113.829 -238.512)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510758",
    "data-name": "Path 510758",
    d: "M210.2,348.9c0,.044-4.2-1.027-9.356-2.4s-9.328-2.5-9.316-2.538,4.2,1.031,9.356,2.4S210.211,348.864,210.2,348.9Z",
    transform: "translate(-124.496 -220.134)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510759",
    "data-name": "Path 510759",
    d: "M207.773,357.284c0,.04-4.2-1.031-9.356-2.4s-9.328-2.5-9.316-2.538,4.2,1.031,9.356,2.4S207.781,357.24,207.773,357.284Z",
    transform: "translate(-123.038 -225.165)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510760",
    "data-name": "Path 510760",
    d: "M206.063,364.814c0,.044-4.2-1.027-9.356-2.4s-9.328-2.5-9.316-2.538,4.2,1.031,9.356,2.4S206.071,364.774,206.063,364.814Z",
    transform: "translate(-122.011 -229.685)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510761",
    "data-name": "Path 510761",
    d: "M204.113,371.994c0,.04-4.2-1.027-9.356-2.4s-9.328-2.5-9.316-2.538,4.2,1.027,9.356,2.4S204.125,371.954,204.113,371.994Z",
    transform: "translate(-120.84 -233.996)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510762",
    "data-name": "Path 510762",
    d: "M663.146,272.27l-4.6,16.662,5.631,4.017,12.674,3.085,5.02-18.809Z",
    transform: "translate(-404.862 -177.092)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510763",
    "data-name": "Path 510763",
    d: "M661,312.09l-2.446.763a7.434,7.434,0,0,0,2,2.306,10.711,10.711,0,0,0,3.653,1.711A7.2,7.2,0,0,1,661,312.09Z",
    transform: "translate(-404.862 -200.997)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510764",
    "data-name": "Path 510764",
    d: "M686.364,292.52c0,.028-3.2-.8-7.138-1.827s-7.114-1.9-7.106-1.934,3.2.8,7.138,1.823S686.372,292.488,686.364,292.52Z",
    transform: "translate(-413.008 -186.99)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510765",
    "data-name": "Path 510765",
    d: "M684.51,298.906c0,.032-3.2-.8-7.134-1.822s-7.114-1.906-7.106-1.934,3.2.8,7.134,1.822S684.518,298.874,684.51,298.906Z",
    transform: "translate(-411.898 -190.827)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510766",
    "data-name": "Path 510766",
    d: "M683.228,304.648c0,.032-3.2-.8-7.138-1.823s-7.114-1.894-7.09-1.938,3.2.8,7.138,1.827S683.236,304.616,683.228,304.648Z",
    transform: "translate(-411.135 -194.271)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510767",
    "data-name": "Path 510767",
    d: "M681.72,310.13c0,.028-3.2-.8-7.134-1.827s-7.114-1.9-7.106-1.934,3.2.8,7.134,1.823S681.728,310.1,681.72,310.13Z",
    transform: "translate(-410.223 -197.562)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510768",
    "data-name": "Path 510768",
    d: "M595.038,46.488l-6.079,1.555-.292,1.858a3.845,3.845,0,0,0,0,1.475,1.2,1.2,0,0,0,.859.915,5.032,5.032,0,0,0,1.763-.128l.12.472L585.69,54.1l-.12-.472a2.634,2.634,0,0,0,1.319-1.163,10.262,10.262,0,0,0,.8-2.97l2.642-15.3.24-.06,9.812,12.522a8.617,8.617,0,0,0,2.1,2.15,2.062,2.062,0,0,0,1.335.144l.12.472-8.321,2.126-.12-.468.344-.088a2.694,2.694,0,0,0,1.335-.639.7.7,0,0,0,.132-.655,1.646,1.646,0,0,0-.2-.452c-.04-.072-.244-.356-.624-.851Zm-.671-.819L590.29,40.4l-1.127,6.587Z",
    transform: "translate(-361.05 -34.13)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204199",
    "data-name": "Rectangle 204199",
    width: 24.544,
    height: 22.334,
    rx: 8.92,
    transform: "translate(248.472 55.293) rotate(1.68)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510769",
    "data-name": "Path 510769",
    d: "M644.1,200.257l8.289-5.559a1.659,1.659,0,0,1,2.17.084l4.081,2.094,5.823-5.7a1.715,1.715,0,0,1,2.478.212l1.9,2.4-.092,9.784a2.8,2.8,0,0,1-2.89,2.774l-19.144-.6A2.8,2.8,0,0,1,644,202.839Z",
    transform: "translate(-396.124 -128.152)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16810",
    "data-name": "Ellipse 16810",
    cx: 2.454,
    cy: 2.454,
    r: 2.454,
    transform: "matrix(0.679, -0.734, 0.734, 0.679, 253.909, 61.649)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204200",
    "data-name": "Rectangle 204200",
    width: 17.058,
    height: 15.523,
    rx: 7.762,
    transform: "translate(10.894 3.034) rotate(1.68)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510770",
    "data-name": "Path 510770",
    d: "M50.194,61.06l5.759-3.877a1.159,1.159,0,0,1,1.511.06L60.3,58.7l4.049-3.957a1.2,1.2,0,0,1,1.723.144L67.4,56.548l-.052,5.272a3.445,3.445,0,0,1-3.553,3.409L53.52,64.9a3.441,3.441,0,0,1-3.333-3.569Z",
    transform: "translate(-39.642 -46.324)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510771",
    "data-name": "Path 510771",
    d: "M65.708,49.9a1.7,1.7,0,1,1-1.779-1.627A1.7,1.7,0,0,1,65.708,49.9Z",
    transform: "translate(-46.918 -42.622)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510772",
    "data-name": "Path 510772",
    d: "M397.876,391.27a10.679,10.679,0,1,1-13.841-6A10.679,10.679,0,0,1,397.876,391.27Z",
    transform: "translate(-236.001 -244.483)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510773",
    "data-name": "Path 510773",
    d: "M399.324,396.008a8.137,8.137,0,1,1-10.547-4.568A8.137,8.137,0,0,1,399.324,396.008Z",
    transform: "translate(-239.814 -248.29)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510774",
    "data-name": "Path 510774",
    d: "M398.914,395.328c-.048.02-.212-.3-.56-.831a8.577,8.577,0,0,0-1.791-1.974,8.315,8.315,0,0,0-1.543-.983,8.2,8.2,0,0,0-2-.663,7.845,7.845,0,0,0-1.123-.14,7.728,7.728,0,0,0-1.175.028,7.948,7.948,0,0,0-3.5,1.2,8.472,8.472,0,0,0-.975.727,7.8,7.8,0,0,0-.827.839,7.517,7.517,0,0,0-.671.911,8.07,8.07,0,0,0-1.227,3.693,8.614,8.614,0,0,0,.208,2.654,4.7,4.7,0,0,1,.22.979,2.43,2.43,0,0,1-.452-.911,7.406,7.406,0,0,1-.4-2.746,7.992,7.992,0,0,1,.292-1.918,8.342,8.342,0,0,1,.887-2.05,7.474,7.474,0,0,1,.7-.991,7.572,7.572,0,0,1,.879-.915,8.693,8.693,0,0,1,1.047-.8,8.334,8.334,0,0,1,2.482-1.067,8.16,8.16,0,0,1,1.3-.216,7.907,7.907,0,0,1,1.267,0,7.723,7.723,0,0,1,1.2.172,8.153,8.153,0,0,1,3.7,1.866,7.594,7.594,0,0,1,1.711,2.19,2.474,2.474,0,0,1,.352.947Z",
    transform: "translate(-239.497 -247.845)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510775",
    "data-name": "Path 510775",
    d: "M400.772,407.092l.54,1.311-1.163.484-.524-1.279a6.019,6.019,0,0,1-3.3.264l.06-1.695a5.12,5.12,0,0,0,2.61-.1l-.8-1.958c-1.427.22-3.057.4-3.745-1.291-.508-1.243-.044-2.678,1.719-3.649l-.536-1.3,1.171-.48.524,1.275a5.672,5.672,0,0,1,2.67-.26v1.679a5.124,5.124,0,0,0-2.042.128l.819,2c1.423-.232,3.03-.4,3.709,1.267C402.978,404.7,402.519,406.117,400.772,407.092Zm-3.293-4.692-.683-1.663c-.564.4-.671.835-.512,1.223S396.9,402.436,397.479,402.4Zm3.169,2c-.168-.4-.6-.492-1.175-.464l.667,1.619c.532-.376.663-.783.508-1.159Z",
    transform: "translate(-246.199 -252.211)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510776",
    "data-name": "Path 510776",
    d: "M44.416,189.53a10.679,10.679,0,1,1-13.841-6,10.679,10.679,0,0,1,13.841,6Z",
    transform: "translate(-23.808 -123.373)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510777",
    "data-name": "Path 510777",
    d: "M45.862,194.275A8.137,8.137,0,1,1,35.314,189.7a8.137,8.137,0,0,1,10.547,4.572Z",
    transform: "translate(-27.62 -127.182)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510778",
    "data-name": "Path 510778",
    d: "M45.442,193.591a4.828,4.828,0,0,1-.556-.831,8.661,8.661,0,0,0-1.791-1.978,8.1,8.1,0,0,0-1.543-.979,8.257,8.257,0,0,0-2-.663,7.833,7.833,0,0,0-2.3-.112,7.745,7.745,0,0,0-3.485,1.207,7.729,7.729,0,0,0-.975.727,8.056,8.056,0,0,0-2.378,3.645,8.226,8.226,0,0,0-.348,1.8,8.5,8.5,0,0,0,.208,2.654,5.06,5.06,0,0,1,.22.979,2.4,2.4,0,0,1-.452-.911,7.494,7.494,0,0,1-.42-2.746,8.185,8.185,0,0,1,.3-1.918,8.277,8.277,0,0,1,.887-2.05,7.821,7.821,0,0,1,.7-.979,7.93,7.93,0,0,1,.883-.915,8.291,8.291,0,0,1,1.047-.8,9.019,9.019,0,0,1,1.2-.635,8.492,8.492,0,0,1,1.283-.448,8.157,8.157,0,0,1,1.3-.216,7.465,7.465,0,0,1,1.267,0,7.716,7.716,0,0,1,1.2.168,8.441,8.441,0,0,1,2.1.767,8.227,8.227,0,0,1,1.6,1.1,7.594,7.594,0,0,1,1.711,2.174A2.314,2.314,0,0,1,45.442,193.591Z",
    transform: "translate(-27.297 -126.738)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510779",
    "data-name": "Path 510779",
    d: "M47.3,205.352l.54,1.311-1.171.48-.524-1.275a6,6,0,0,1-3.3.26l.06-1.691a5.08,5.08,0,0,0,2.61-.1l-.8-1.954c-1.427.22-3.057.38-3.745-1.291-.512-1.243-.048-2.678,1.719-3.649l-.536-1.3,1.171-.48.524,1.275a5.727,5.727,0,0,1,2.67-.264v1.683a5.2,5.2,0,0,0-2.042.124l.819,2c1.423-.232,3.03-.4,3.7,1.267C49.5,202.954,49.043,204.377,47.3,205.352ZM44,200.66l-.679-1.667c-.564.4-.671.835-.512,1.219S43.42,200.708,44,200.66Zm3.173,2c-.168-.4-.6-.5-1.175-.464l.663,1.6c.536-.356.667-.767.512-1.139Z",
    transform: "translate(-33.991 -131.101)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510780",
    "data-name": "Path 510780",
    d: "M126.94,108.18l.024.1h0Z",
    transform: "translate(-85.721 -78.584)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-13",
    transform: "translate(31.479 202.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510781",
    "data-name": "Path 510781",
    d: "M304.753,455.49h3.637v.048l-130.872.08L82.4,455.586l-28.828-.032h0l28.828-.036,95.122-.028,130.872.08v.048h-2.746A5.984,5.984,0,0,0,304.753,455.49Z",
    transform: "translate(-43 -455.49)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books-2--inject-13",
    transform: "translate(187.698 158.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510782",
    "data-name": "Path 510782",
    d: "M530.6,376.56h58.752a1,1,0,0,1,1,1v.4a1,1,0,0,1-1,1H530.6V376.56Z",
    transform: "translate(-491.94 -364.35)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510783",
    "data-name": "Path 510783",
    d: "M495.544,379.974c0,.052-4.928.088-11.007.088s-11.007-.036-11.007-.088,4.928-.084,11.007-.084S495.544,379.934,495.544,379.974Z",
    transform: "translate(-457.679 -366.361)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510784",
    "data-name": "Path 510784",
    d: "M470.7,346.07h27.577V360.7H470.7a6.051,6.051,0,0,1-6.051-6.051v-2.526a6.051,6.051,0,0,1,6.051-6.051Z",
    transform: "translate(-452.348 -346.058)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510785",
    "data-name": "Path 510785",
    d: "M531.056,346.07H589.34a1,1,0,0,1,1,1v.4a1,1,0,0,1-1,1H531.056a.456.456,0,0,1-.456-.436v-1.515a.456.456,0,0,1,.456-.456Z",
    transform: "translate(-491.94 -346.058)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510786",
    "data-name": "Path 510786",
    d: "M591.232,361.918H539.938a4.888,4.888,0,0,1-4.888-4.884h0a4.888,4.888,0,0,1,4.888-4.884h51.294A12.082,12.082,0,0,0,591.232,361.918Z",
    transform: "translate(-494.611 -349.708)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633199",
    "data-name": "Group 633199",
    transform: "translate(12.306)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510787",
    "data-name": "Path 510787",
    d: "M492.793,360.68H470.2a5.539,5.539,0,0,1-5.539-5.543v-3.6a5.5,5.5,0,0,1,5.5-5.5h23.181C488.057,349.261,488.452,356.943,492.793,360.68Z",
    transform: "translate(-464.66 -346.04)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510788",
    "data-name": "Path 510788",
    d: "M589.359,365.378c0,.048-10.531.088-23.513.088s-23.517-.04-23.517-.088,10.527-.088,23.517-.088S589.359,365.33,589.359,365.378Z",
    transform: "translate(-498.982 -357.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510789",
    "data-name": "Path 510789",
    d: "M601.5,370.808c0,.048-10.531.088-23.517.088s-23.513-.04-23.513-.088,10.523-.088,23.513-.088S601.5,370.76,601.5,370.808Z",
    transform: "translate(-506.27 -360.856)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510790",
    "data-name": "Path 510790",
    d: "M597.929,357.668c0,.048-10.531.088-23.517.088s-23.513-.04-23.513-.088,10.523-.088,23.513-.088S597.929,357.62,597.929,357.668Z",
    transform: "translate(-504.126 -352.968)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510791",
    "data-name": "Path 510791",
    d: "M495.544,348.978c0,.048-4.928.088-11.007.088s-11.007-.04-11.007-.088,4.928-.088,11.007-.088S495.544,348.934,495.544,348.978Z",
    transform: "translate(-457.679 -347.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510792",
    "data-name": "Path 510792",
    d: "M441.66,408.36h32.513a3.022,3.022,0,0,1,3.022,3.022v12.789a3.022,3.022,0,0,1-3.022,3.022H441.66a7.79,7.79,0,0,1-7.79-7.786v-3.253A7.79,7.79,0,0,1,441.66,408.36Z",
    transform: "translate(-433.87 -383.452)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510793",
    "data-name": "Path 510793",
    d: "M519.537,408.36h74.9a1.3,1.3,0,0,1,1.295,1.295v.54a1.3,1.3,0,0,1-1.295,1.295h-74.9a.747.747,0,0,1-.747-.747v-1.635A.747.747,0,0,1,519.537,408.36Z",
    transform: "translate(-484.85 -383.452)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510794",
    "data-name": "Path 510794",
    d: "M519.537,447.66h74.9a1.3,1.3,0,0,1,1.295,1.295v.54a1.3,1.3,0,0,1-1.295,1.295h-74.9a.747.747,0,0,1-.747-.747v-1.635A.747.747,0,0,1,519.537,447.66Z",
    transform: "translate(-484.85 -407.045)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510795",
    "data-name": "Path 510795",
    d: "M596.883,428.762H530.821a6.291,6.291,0,0,1-6.291-6.291h0a6.291,6.291,0,0,1,6.291-6.291h66.062A15.531,15.531,0,0,0,596.883,428.762Z",
    transform: "translate(-488.296 -388.147)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633200",
    "data-name": "Group 633200",
    transform: "translate(0 24.908)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510796",
    "data-name": "Path 510796",
    d: "M470.1,427.2H443.186a9.316,9.316,0,0,1-9.316-9.316h0a9.516,9.516,0,0,1,9.516-9.52H470.82C464,412.493,464.509,422.384,470.1,427.2Z",
    transform: "translate(-433.87 -408.36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510797",
    "data-name": "Path 510797",
    d: "M594.506,433.254c0,.052-13.561.088-30.283.088s-30.283-.036-30.283-.088,13.553-.084,30.283-.084S594.506,433.206,594.506,433.254Z",
    transform: "translate(-493.945 -398.347)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510798",
    "data-name": "Path 510798",
    d: "M610.1,440.248c0,.048-13.561.088-30.283.088s-30.283-.04-30.283-.088,13.557-.088,30.283-.088S610.1,440.2,610.1,440.248Z",
    transform: "translate(-503.304 -402.543)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510799",
    "data-name": "Path 510799",
    d: "M605.5,426.758c0,.048-13.557.088-30.279.088s-30.287-.04-30.287-.088,13.557-.088,30.287-.088S605.5,426.71,605.5,426.758Z",
    transform: "translate(-500.542 -394.445)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510800",
    "data-name": "Path 510800",
    d: "M473.649,452.054c0,.052-6.347.088-14.172.088s-14.176-.036-14.176-.088,6.343-.084,14.176-.084S473.649,452.006,473.649,452.054Z",
    transform: "translate(-440.732 -409.633)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510801",
    "data-name": "Path 510801",
    d: "M473.649,412.138c0,.048-6.347.088-14.172.088s-14.176-.04-14.176-.088,6.343-.088,14.176-.088S473.649,412.09,473.649,412.138Z",
    transform: "translate(-440.732 -385.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510802",
    "data-name": "Path 510802",
    d: "M486.81,381.544h30.531a.208.208,0,0,1,.208.208v10.363a.208.208,0,0,1-.208.208H486.81a4.46,4.46,0,0,1-4.46-4.46V386a4.46,4.46,0,0,1,4.46-4.46Z",
    transform: "translate(-462.974 -367.352)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510803",
    "data-name": "Path 510803",
    d: "M551.82,381.55H612.8a1.051,1.051,0,0,1,1.051,1.051v.44a1.051,1.051,0,0,1-1.051,1.051H551.82a.48.48,0,0,1-.48-.48v-1.6A.48.48,0,0,1,551.82,381.55Z",
    transform: "translate(-504.391 -367.358)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510804",
    "data-name": "Path 510804",
    d: "M551.82,402.17H612.8a1.051,1.051,0,0,1,1.051,1.051v.44a1.051,1.051,0,0,1-1.051,1.051H551.82a.48.48,0,0,1-.48-.48v-1.6A.48.48,0,0,1,551.82,402.17Z",
    transform: "translate(-504.391 -379.736)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510805",
    "data-name": "Path 510805",
    d: "M614.788,393.579H558.834A2.85,2.85,0,0,1,556,390.714h0a2.854,2.854,0,0,1,2.85-2.854H614.8A4.311,4.311,0,0,0,614.788,393.579Z",
    transform: "translate(-507.188 -371.146)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633201",
    "data-name": "Group 633201",
    transform: "translate(19.376 14.192)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510806",
    "data-name": "Path 510806",
    d: "M511.786,392.333H487.7a5.348,5.348,0,0,1-5.348-5.348h0a5.436,5.436,0,0,1,5.436-5.436h24.584C506.83,383.912,507.246,389.579,511.786,392.333Z",
    transform: "translate(-482.35 -381.55)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510807",
    "data-name": "Path 510807",
    d: "M612.858,393.784c0,.052-11.015.088-24.6.088s-24.6-.036-24.6-.088,11.015-.084,24.6-.084S612.858,393.736,612.858,393.784Z",
    transform: "translate(-511.781 -374.652)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510808",
    "data-name": "Path 510808",
    d: "M625.528,397.628c0,.048-11.015.084-24.6.084s-24.6-.036-24.6-.084,11.015-.088,24.6-.088S625.528,397.576,625.528,397.628Z",
    transform: "translate(-519.387 -376.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510809",
    "data-name": "Path 510809",
    d: "M514.663,405.718c0,.048-5.156.088-11.515.088s-11.519-.04-11.519-.088,5.156-.088,11.519-.088S514.663,405.67,514.663,405.718Z",
    transform: "translate(-468.545 -381.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510810",
    "data-name": "Path 510810",
    d: "M514.663,384.594c0,.052-5.156.088-11.515.088s-11.519-.036-11.519-.088,5.156-.084,11.519-.084S514.663,384.546,514.663,384.594Z",
    transform: "translate(-468.545 -369.135)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510811",
    "data-name": "Path 510811",
    d: "M578.995,381.418c0,.048-18.916.084-42.245.084s-42.249-.036-42.249-.084,18.912-.088,42.249-.088S578.995,381.37,578.995,381.418Z",
    transform: "translate(-470.268 -367.226)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510812",
    "data-name": "Path 510812",
    d: "M621.03,357.4v5.859l2.03-1.3,2.266,1.3V357.4Z",
    transform: "translate(-546.228 -352.86)",
    fill: "#356f92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-1--inject-13",
    transform: "translate(123.098 35.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510813",
    "data-name": "Path 510813",
    d: "M294.517,51.182H274.242a1.715,1.715,0,0,1-1.715-1.8l.4-8.589a1.719,1.719,0,0,1,1.715-1.635h20.271a1.719,1.719,0,0,1,1.719,1.8l-.4,8.589A1.719,1.719,0,0,1,294.517,51.182Z",
    transform: "translate(-272.41 -38.964)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510814",
    "data-name": "Path 510814",
    d: "M294.344,50.888a2.022,2.022,0,0,0,.667-.156,1.715,1.715,0,0,0,1.011-1.559c.076-1.743.184-4.245.316-7.334,0-.763.252-1.647-.316-2.29a1.6,1.6,0,0,0-1.051-.584c-.4-.032-.883,0-1.331,0H274.484a1.623,1.623,0,0,0-1.383.775,1.69,1.69,0,0,0-.236.8c0,.292-.028.58-.04.867-.056,1.151-.112,2.286-.164,3.4s-.108,2.21-.16,3.281c0,.268-.028.536-.04.8a1.974,1.974,0,0,0,.052.755,1.631,1.631,0,0,0,.951,1.051,1.779,1.779,0,0,0,.711.12H284.3l7.346.032h2.7a1.023,1.023,0,0,1-.18,0H291.65l-7.346.032H274.176a1.915,1.915,0,0,1-.8-.132,1.811,1.811,0,0,1-1.067-1.175,2.175,2.175,0,0,1-.06-.8l.036-.8.156-3.281c.052-1.115.108-2.25.16-3.4,0-.284.028-.576.044-.863a1.871,1.871,0,0,1,.26-.879,1.834,1.834,0,0,1,1.563-.875h19.156c.46,0,.891,0,1.351.02a1.8,1.8,0,0,1,1.555,1.858q-.028.608-.06,1.2c-.16,3.089-.292,5.6-.4,7.334a1.747,1.747,0,0,1-.4,1.083,1.675,1.675,0,0,1-.679.508,1.779,1.779,0,0,1-.508.124A1.2,1.2,0,0,1,294.344,50.888Z",
    transform: "translate(-272.237 -38.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510815",
    "data-name": "Path 510815",
    d: "M485.35,58.038l.867-5.428,3.7-2.15,3.037,3.257-.915,5.563Z",
    transform: "translate(-400.175 -45.748)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510816",
    "data-name": "Path 510816",
    d: "M406.223,73.128l-4.488,98.487-72.361-2.054-4.3-7.522,7.782-91.533L400.2,66.05Z",
    transform: "translate(-303.954 -55.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633202",
    "data-name": "Group 633202",
    transform: "translate(91.754 10.943)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510817",
    "data-name": "Path 510817",
    d: "M507.837,171.615l-6.027-7.078L506.3,66.05l6.027,7.078Z",
    transform: "translate(-501.81 -66.05)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510818",
    "data-name": "Path 510818",
    d: "M400.2,64.555l-4.488,98.487-70.638-2.5,5.344-96.984Z",
    transform: "translate(-303.954 -53.612)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510819",
    "data-name": "Path 510819",
    d: "M400.03,64.435l-69.783-.911.084-.08c-1.487,27.1-3.329,60.674-5.324,96.988l-.1-.112,1.167.04,69.471,2.466-.1.092c2.722-58.164,4.56-97.644,4.584-98.483-.04.839-1.8,40.323-4.4,98.491v.092h-.1l-69.447-2.45-1.167-.04h-.1v-.1c2-36.314,3.865-69.883,5.364-96.984v-.08h.08Z",
    transform: "translate(-303.804 -53.492)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204201",
    "data-name": "Rectangle 204201",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(60.196 34.442) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204202",
    "data-name": "Rectangle 204202",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(59.959 39.859) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204203",
    "data-name": "Rectangle 204203",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(59.718 45.272) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204204",
    "data-name": "Rectangle 204204",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(59.485 50.685) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204205",
    "data-name": "Rectangle 204205",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(59.248 56.098) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204206",
    "data-name": "Rectangle 204206",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(59.007 61.515) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204207",
    "data-name": "Rectangle 204207",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(58.774 66.928) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204208",
    "data-name": "Rectangle 204208",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(88.267 62.324) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204209",
    "data-name": "Rectangle 204209",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(88.026 67.737) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204210",
    "data-name": "Rectangle 204210",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(87.741 73.447) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204211",
    "data-name": "Rectangle 204211",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(87.453 79.153) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204212",
    "data-name": "Rectangle 204212",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(87.169 84.863) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204213",
    "data-name": "Rectangle 204213",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(86.88 90.574) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204214",
    "data-name": "Rectangle 204214",
    width: 26.554,
    height: 2.802,
    rx: 1.401,
    transform: "translate(86.592 96.28) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510820",
    "data-name": "Path 510820",
    d: "M347.787,284.147l54.443,1.6a.939.939,0,0,0,.967-.911l.024-.923a.935.935,0,0,0-.907-.963l-54.443-1.6a.939.939,0,0,0-.967.911l-.024.923A.939.939,0,0,0,347.787,284.147Z",
    transform: "translate(-317.047 -184.357)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204215",
    "data-name": "Rectangle 204215",
    width: 18.517,
    height: 2.802,
    rx: 1.401,
    transform: "translate(52.588 27.161) rotate(-178.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510821",
    "data-name": "Path 510821",
    d: "M334.84,175.5l.344.02,1.011.044,3.909.148,14.5.512,49,1.655h.1v-.1c.184-3.9.376-7.993.576-12.138,1.043-22.334,2-42.553,2.678-57.193.332-7.318.6-13.237.8-17.334.088-2.042.156-3.629.2-4.712.02-.536.036-.947.044-1.227s0-.4,0-.4a3.593,3.593,0,0,1-.032.4c-.032.256-.04.687-.068,1.223-.056,1.083-.14,2.67-.244,4.712-.2,4.1-.5,10.016-.855,17.33-.7,14.64-1.671,34.855-2.742,57.193-.2,4.157-.4,8.241-.576,12.134l.112-.1-49-1.6-14.508-.428-3.909-.112-1.011-.024Z",
    transform: "translate(-309.819 -66.345)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510822",
    "data-name": "Path 510822",
    d: "M349.2,180.918s.108,0,.324.024l.955.044,3.693.148,13.733.524,46.562,1.707h.1v-.1c.248-4.7.508-9.592.771-14.58,1.147-22.042,2.186-41.989,2.938-56.438.368-7.218.663-13.057.867-17.1.1-2,.176-3.6.228-4.652.02-.528.04-.931.052-1.2a3.322,3.322,0,0,0,0-.4,3.657,3.657,0,0,1-.032.4c-.032.26-.04.683-.072,1.2-.064,1.067-.152,2.634-.268,4.648-.22,4.041-.54,9.884-.935,17.1-.767,14.444-1.831,34.4-3,56.434-.264,5-.52,9.88-.767,14.58l.108-.1L367.9,181.522l-13.729-.46-3.693-.116-.955-.024Z",
    transform: "translate(-318.44 -68.818)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510823",
    "data-name": "Path 510823",
    d: "M407.72,61.333l1.067-1.043,12.722.064.615,1.163Z",
    transform: "translate(-353.571 -51.649)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204216",
    "data-name": "Rectangle 204216",
    width: 6.063,
    height: 14.404,
    transform: "translate(68.557 9.866) rotate(90.72)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204217",
    "data-name": "Rectangle 204217",
    width: 1.211,
    height: 15.403,
    rx: 0.606,
    transform: "translate(68.979 15.42) rotate(90.72)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510824",
    "data-name": "Path 510824",
    d: "M423.2,57.028h0l-6.335-.08a.56.56,0,0,1-.456-.244.571.571,0,0,1-.064-.508l1.842-5.02a3.317,3.317,0,1,1,3.877.064l1.663,5.052a.559.559,0,0,1-.08.508A.551.551,0,0,1,423.2,57.028Zm-3.014-11.415h-.076a2.958,2.958,0,0,0-2.834,2.954,2.914,2.914,0,0,0,1.291,2.37l.128.088-1.982,5.324a.16.16,0,0,0,.02.148.148.148,0,0,0,.128.068l6.335.08a.164.164,0,0,0,.132-.064.168.168,0,0,0,.02-.144l-1.763-5.364.136-.084a2.91,2.91,0,0,0-1.535-5.376Z",
    transform: "translate(-358.727 -42.628)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510825",
    "data-name": "Path 510825",
    d: "M421.99,76.942h-.548l-1.523-.032-5.024-.084-5.024-.072h-1.938a.707.707,0,0,0-.144,0h.144l.4.02,1.539.076c1.287.032,3.061.064,5.024.092s3.741.044,5.028.048h1.922a.5.5,0,0,0,.144-.048Z",
    transform: "translate(-353.613 -61.531)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510826",
    "data-name": "Path 510826",
    d: "M422.506,62.786a.591.591,0,0,0-.144,0h-.4l-1.523-.032-5.024-.08-5.024-.06h-1.938a.659.659,0,0,0-.144,0h.544l1.523.04c1.287.032,3.065.064,5.028.092s3.737.044,5.024.048h1.922a.659.659,0,0,0,.156-.008Z",
    transform: "translate(-353.925 -53.042)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204218",
    "data-name": "Rectangle 204218",
    width: 24.544,
    height: 22.334,
    rx: 8.92,
    transform: "translate(32.338 70.201) rotate(1.68)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510827",
    "data-name": "Path 510827",
    d: "M351.791,242.414a.6.6,0,0,1,.264-.476l8.033-5.392a1.663,1.663,0,0,1,2.122.04.6.6,0,0,0,.1.072l3.641,1.87a.608.608,0,0,0,.7-.1l5.511-5.4a1.719,1.719,0,0,1,2.482.212l1.767,2.222a.591.591,0,0,1,.132.38l-.084,8.973a3.385,3.385,0,0,1-3.5,3.353l-17.953-.568a3.389,3.389,0,0,1-3.281-3.509Z",
    transform: "translate(-319.956 -155.09)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16811",
    "data-name": "Ellipse 16811",
    cx: 2.461,
    cy: 2.461,
    r: 2.461,
    transform: "matrix(0.937, -0.349, 0.349, 0.937, 38.526, 75.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204219",
    "data-name": "Rectangle 204219",
    width: 24.544,
    height: 22.334,
    rx: 8.92,
    transform: "translate(64.081 32.541) rotate(1.718)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510828",
    "data-name": "Path 510828",
    d: "M431.158,147.524l8.3-5.559a1.659,1.659,0,0,1,2.17.084l4.081,2.094,5.827-5.7a1.711,1.711,0,0,1,2.478.212l1.9,2.4-.08,8.593a4,4,0,0,1-4.1,3.933l-16.786-.532a3.973,3.973,0,0,1-3.841-4.117Z",
    transform: "translate(-367.609 -98.309)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16812",
    "data-name": "Ellipse 16812",
    cx: 2.454,
    cy: 2.454,
    r: 2.454,
    transform: "translate(70.491 36.166)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510829",
    "data-name": "Path 510829",
    d: "M359.063,144.528a1.155,1.155,0,0,1-.324-.092,1.79,1.79,0,0,1-.731-.619,2.086,2.086,0,0,1-.356-1.467,2.906,2.906,0,0,1,.971-1.751,5.092,5.092,0,0,1,2.182-1.075,11.91,11.91,0,0,1,2.774-.356,12.2,12.2,0,0,1,6.151,1.559,4.533,4.533,0,0,1,1.3,1.1,2.73,2.73,0,0,1,.583,1.555,2.082,2.082,0,0,1-.583,1.495,3.5,3.5,0,0,1-1.3.8,8.709,8.709,0,0,1-2.758.444,15.216,15.216,0,0,1-2.43-.1,14.98,14.98,0,0,1-3.413-.823,8.908,8.908,0,0,1-.883-.364,2.567,2.567,0,0,1-.3-.148,1.975,1.975,0,0,1,.312.112c.2.08.5.192.9.324a16.388,16.388,0,0,0,3.413.783,16.09,16.09,0,0,0,2.4.076,8.677,8.677,0,0,0,2.7-.452,3.23,3.23,0,0,0,1.223-.771,1.867,1.867,0,0,0,.524-1.351,2.482,2.482,0,0,0-.544-1.435,4.276,4.276,0,0,0-1.247-1.043,12.142,12.142,0,0,0-6.043-1.547,12.015,12.015,0,0,0-2.73.332,5.02,5.02,0,0,0-2.13,1.019,2.8,2.8,0,0,0-.951,1.655,2,2,0,0,0,.308,1.407,1.839,1.839,0,0,0,.683.627C358.952,144.492,359.067,144.516,359.063,144.528Z",
    transform: "translate(-323.503 -99.001)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510830",
    "data-name": "Path 510830",
    d: "M384.909,284.223a1.043,1.043,0,0,1-.324-.088,1.79,1.79,0,0,1-.731-.62,2.09,2.09,0,0,1-.36-1.467,2.938,2.938,0,0,1,.971-1.751,5.132,5.132,0,0,1,2.186-1.075,11.875,11.875,0,0,1,2.77-.356,12.154,12.154,0,0,1,6.151,1.559,4.484,4.484,0,0,1,1.307,1.1,2.722,2.722,0,0,1,.584,1.555,2.066,2.066,0,0,1-.584,1.491,3.4,3.4,0,0,1-1.3.8,8.837,8.837,0,0,1-2.762.448,16.137,16.137,0,0,1-2.426-.1,15.42,15.42,0,0,1-3.413-.823c-.4-.144-.687-.272-.883-.364a1.872,1.872,0,0,1-.3-.152,2.324,2.324,0,0,1,.316.112c.2.08.5.2.891.328a16.283,16.283,0,0,0,3.405.751,16.051,16.051,0,0,0,2.4.08,8.685,8.685,0,0,0,2.7-.456,3.261,3.261,0,0,0,1.223-.771,1.875,1.875,0,0,0,.524-1.351,2.55,2.55,0,0,0-.544-1.435,4.329,4.329,0,0,0-1.247-1.039,12.2,12.2,0,0,0-8.793-1.2,4.972,4.972,0,0,0-2.13,1.015,2.834,2.834,0,0,0-.955,1.659,2,2,0,0,0,.312,1.407,1.81,1.81,0,0,0,.679.623C384.8,284.191,384.909,284.211,384.909,284.223Z",
    transform: "translate(-339.017 -182.867)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510831",
    "data-name": "Path 510831",
    d: "M354.9,98.778a1.155,1.155,0,0,1-.32-.092,1.759,1.759,0,0,1-.731-.619,2.062,2.062,0,0,1-.36-1.463,2.946,2.946,0,0,1,.991-1.755,5.1,5.1,0,0,1,2.186-1.071,12.086,12.086,0,0,1,2.77-.36,12.234,12.234,0,0,1,6.151,1.559,4.48,4.48,0,0,1,1.3,1.1,2.706,2.706,0,0,1,.588,1.555,2.074,2.074,0,0,1-.583,1.495,3.445,3.445,0,0,1-1.3.8,8.733,8.733,0,0,1-2.762.444,15.347,15.347,0,0,1-5.843-.927,9.344,9.344,0,0,1-.883-.364,2.568,2.568,0,0,1-.3-.148,1.775,1.775,0,0,1,.316.112c.2.08.5.192.891.324a16.5,16.5,0,0,0,3.405.755,15.522,15.522,0,0,0,2.4.076,8.7,8.7,0,0,0,2.7-.452,3.246,3.246,0,0,0,1.219-.771,1.887,1.887,0,0,0,.528-1.323,2.526,2.526,0,0,0-.548-1.435,4.273,4.273,0,0,0-1.243-1.043,12.21,12.21,0,0,0-8.793-1.2,5.028,5.028,0,0,0-2.126,1.019,2.8,2.8,0,0,0-.955,1.655,2.022,2.022,0,0,0,.308,1.407,1.87,1.87,0,0,0,.683.627A2,2,0,0,1,354.9,98.778Z",
    transform: "translate(-321.006 -71.536)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510832",
    "data-name": "Path 510832",
    d: "M509.984,247.14l5.5.136,2.622,3.377-2.822,3.445-5.639-.168Z",
    transform: "translate(-414.757 -163.82)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510833",
    "data-name": "Path 510833",
    d: "M511.284,223.02l5.5.136,2.622,3.377-2.822,3.445-5.639-.168Z",
    transform: "translate(-415.537 -149.341)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204220",
    "data-name": "Rectangle 204220",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(3.279 4.372)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204221",
    "data-name": "Rectangle 204221",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(3.279 5.959)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204222",
    "data-name": "Rectangle 204222",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(3.279 7.542)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510834",
    "data-name": "Path 510834",
    d: "M333,53.31c.044-.032,2.8,3.549,6.175,7.993s6.059,8.093,6,8.125-2.8-3.545-6.175-7.993S332.947,53.346,333,53.31Z",
    transform: "translate(-308.714 -47.458)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16813",
    "data-name": "Ellipse 16813",
    cx: 0.675,
    cy: 0.675,
    r: 0.675,
    transform: "translate(23.502 4.856)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510835",
    "data-name": "Path 510835",
    d: "M346.807,377.672H326.536a1.719,1.719,0,0,1-1.719-1.8l.4-8.589a1.719,1.719,0,0,1,1.719-1.635h20.271a1.715,1.715,0,0,1,1.715,1.8l-.4,8.589a1.719,1.719,0,0,1-1.715,1.635Z",
    transform: "translate(-303.801 -234.965)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510836",
    "data-name": "Path 510836",
    d: "M346.636,377.552a2,2,0,0,0,.671-.16,1.7,1.7,0,0,0,1.007-1.555c.076-1.743.184-4.249.32-7.338,0-.759.248-1.643-.316-2.286a1.626,1.626,0,0,0-1.051-.588c-.42-.028-.883,0-1.335,0H326.776a1.6,1.6,0,0,0-1.379.775,1.63,1.63,0,0,0-.236.779c0,.288-.028.58-.04.867q-.084,1.727-.164,3.4t-.16,3.281c0,.268-.028.536-.04.8a1.951,1.951,0,0,0,.052.751,1.627,1.627,0,0,0,.951,1.055,1.766,1.766,0,0,0,.711.116h10.14l7.342.032,2,.02h.52a.847.847,0,0,1,.176,0h-.7l-2,.02-7.342.036-5.1.1h-5.04a1.971,1.971,0,0,1-.8-.132,1.819,1.819,0,0,1-1.067-1.175,2.182,2.182,0,0,1-.064-.8c0-.268.028-.532.04-.8.052-1.075.1-2.17.156-3.281s.1-2.25.16-3.4c0-.288.028-.576.04-.867a1.894,1.894,0,0,1,.264-.875,1.838,1.838,0,0,1,1.559-.879h19.156c.464,0,.9,0,1.355.02a1.794,1.794,0,0,1,1.155.647,1.834,1.834,0,0,1,.4,1.2q-.032.6-.06,1.2c-.164,3.089-.3,5.6-.4,7.334a1.77,1.77,0,0,1-.4,1.083,1.731,1.731,0,0,1-.679.508,1.927,1.927,0,0,1-.508.124Z",
    transform: "translate(-303.63 -234.845)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204223",
    "data-name": "Rectangle 204223",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(24.177 134.861)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204224",
    "data-name": "Rectangle 204224",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(24.177 136.444)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204225",
    "data-name": "Rectangle 204225",
    width: 17.793,
    height: 0.5,
    rx: 0.25,
    transform: "translate(24.177 138.031)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510837",
    "data-name": "Path 510837",
    d: "M376.973,295.22c.052.028-3.2,6.351-7.238,14.12s-7.374,14.052-7.426,14.028,3.2-6.351,7.242-14.124S376.937,295.2,376.973,295.22Z",
    transform: "translate(-326.309 -192.684)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510838",
    "data-name": "Path 510838",
    d: "M362.009,364.629a.679.679,0,1,1-.679-.679A.679.679,0,0,1,362.009,364.629Z",
    transform: "translate(-325.314 -233.945)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-13",
    transform: "translate(264.206 63.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510839",
    "data-name": "Path 510839",
    d: "M650.611,106.75H632.486a6.95,6.95,0,0,0-6.946,6.95h0a6.946,6.946,0,0,0,6.547,6.93c.548.943,1.091,1.89,1.639,2.838l2.05-2.818h14.836a6.954,6.954,0,0,0,6.95-6.95h0a6.954,6.954,0,0,0-6.95-6.95Z",
    transform: "translate(-625.443 -106.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510840",
    "data-name": "Path 510840",
    d: "M650.466,106.576h.727a7.351,7.351,0,0,1,2.03.512,7.2,7.2,0,0,1,2.662,2,7.594,7.594,0,0,1,1.075,1.8,7.038,7.038,0,0,1-1.255,7.314,7.159,7.159,0,0,1-2.45,1.783,7.53,7.53,0,0,1-3.173.584H635.63l.084-.04-2.05,2.8-.092.132-.08-.14-.667-1.155-.975-1.683.084.048a7.593,7.593,0,0,1-2.03-.424,7.438,7.438,0,0,1-1.795-.979,7.03,7.03,0,0,1-1.079-10.244,6.943,6.943,0,0,1,2.854-1.97c.136-.048.264-.1.4-.144l.4-.1a6.393,6.393,0,0,1,.819-.148c.272-.036.544-.032.8-.052h6.639l8.425.036h0l-8.425.032H632.3a4.155,4.155,0,0,0-.8.052,7.012,7.012,0,0,0-.8.148l-.4.1c-.132.04-.26.092-.4.14a6.762,6.762,0,0,0-2.726,2.062,6.838,6.838,0,0,0,1.059,9.956,7.363,7.363,0,0,0,1.743.951,7.653,7.653,0,0,0,1.97.4H632l.028.048.975,1.683.667,1.155H633.5l2.05-2.822.032-.04h14.5a7.286,7.286,0,0,0,3.1-.56,7.014,7.014,0,0,0,2.4-1.735,6.914,6.914,0,0,0,1.259-7.154,7.348,7.348,0,0,0-1.047-1.779,7.194,7.194,0,0,0-2.6-2,7.79,7.79,0,0,0-2.73-.564Z",
    transform: "translate(-625.297 -106.46)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510841",
    "data-name": "Path 510841",
    d: "M642.512,118.71l.651,1.315,1.451.212-1.051,1.023.248,1.447-1.3-.683-1.3.683.248-1.447-1.051-1.023,1.451-.212Z",
    transform: "translate(-634.37 -113.814)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510842",
    "data-name": "Path 510842",
    d: "M656.306,118.71l.647,1.315,1.455.212-1.051,1.023.248,1.447-1.3-.683-1.3.683.248-1.447-1.051-1.023,1.455-.212Z",
    transform: "translate(-642.648 -113.814)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510843",
    "data-name": "Path 510843",
    d: "M670.1,118.71l.651,1.315,1.451.212-1.051,1.023.248,1.447-1.3-.683-1.3.683.248-1.447L668,120.237l1.451-.212Z",
    transform: "translate(-650.933 -113.814)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510844",
    "data-name": "Path 510844",
    d: "M683.892,118.71l.651,1.315,1.455.212-1.051,1.023.248,1.447-1.3-.683-1.3.683.248-1.447-1.051-1.023,1.455-.212Z",
    transform: "translate(-659.212 -113.814)",
    fill: "#356f92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-13",
    transform: "translate(74.503 70.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510845",
    "data-name": "Path 510845",
    d: "M150.7,139.729l2.958.284a9.571,9.571,0,1,0-1.6-3.03h0Z",
    transform: "translate(-150.68 -124.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510846",
    "data-name": "Path 510846",
    d: "M150.67,139.642s.036-.064.1-.184.156-.3.272-.528c.236-.468.58-1.143,1.027-2.018h-.076a.04.04,0,0,0,.06,0,.036.036,0,0,0,0-.048,9.592,9.592,0,0,1-.252-4.648,9.463,9.463,0,0,1,17.633-2.674l.268.516.22.536a10.605,10.605,0,0,1,.356,1.1,9.756,9.756,0,0,1,.28,2.242,9.487,9.487,0,0,1-16.91,5.947h-.032l-2.19-.184-.572-.044h-.2l.18.024.56.064,2.214.24h-.028a9.476,9.476,0,0,0,3.709,2.89,9.668,9.668,0,0,0,12.5-4.58,9.808,9.808,0,0,0,.691-6.607,10.087,10.087,0,0,0-.364-1.115l-.224-.552-.272-.528a9.636,9.636,0,0,0-14.664-2.846,9.532,9.532,0,0,0-2.21,2.69,9.332,9.332,0,0,0-1.055,2.89,9.568,9.568,0,0,0,.3,4.7l.08-.036h0a.044.044,0,0,0-.06,0h0l-.991,2.07c-.108.224-.188.4-.248.524A1.2,1.2,0,0,0,150.67,139.642Z",
    transform: "translate(-150.65 -124.405)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510847",
    "data-name": "Path 510847",
    d: "M172.987,145.845v1.071h-.959v-1.043a4.572,4.572,0,0,1-2.378-.8l.544-1.163a3.9,3.9,0,0,0,1.85.7l.024-1.6c-1.063-.272-2.246-.643-2.23-2,0-1.019.763-1.878,2.282-2.034V137.92h.959v1.047a4.332,4.332,0,0,1,1.938.611l-.508,1.171a3.917,3.917,0,0,0-1.459-.52l-.024,1.631c1.063.264,2.226.635,2.21,2C175.225,144.83,174.482,145.682,172.987,145.845Zm-.9-4.253V140.23c-.512.112-.715.4-.719.7s.288.52.707.659Zm1.6,2.334c0-.336-.272-.524-.679-.671l-.02,1.323c.492-.1.7-.344.707-.631Z",
    transform: "translate(-162.056 -132.518)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-13",
    transform: "translate(25.344 63.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510848",
    "data-name": "Path 510848",
    d: "M46.291,124.19l-.775-2.874a9.592,9.592,0,1,0-2.274,2.566h0Z",
    transform: "translate(-27.694 -106.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510849",
    "data-name": "Path 510849",
    d: "M46.247,124.16l-.208-.028-.588-.068-2.25-.252.032.072h0a.044.044,0,0,0,0-.064.04.04,0,0,0-.052,0,9.5,9.5,0,0,1-10.527.759,9.463,9.463,0,0,1-2.466-14.452l.4-.432.424-.4a10.274,10.274,0,0,1,.9-.719,9.486,9.486,0,0,1,13.525,12.682v.032c.256.915.46,1.623.6,2.114.068.236.12.4.16.552a1.5,1.5,0,0,0,.06.2,1.624,1.624,0,0,0-.04-.18l-.14-.548-.552-2.158v.036a9.632,9.632,0,0,0-7.3-14.564,9.772,9.772,0,0,0-6.431,1.679,10.053,10.053,0,0,0-.915.731l-.436.4-.4.44a9.618,9.618,0,0,0,13.185,13.9l-.06-.06h0a.04.04,0,0,0,0,.06h.024l2.286.2.58.048Z",
    transform: "translate(-27.65 -106.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510850",
    "data-name": "Path 510850",
    d: "M43.784,129.765l-5.024-3.357,1.175-1.755,3.365,2.254,4.193-5.547,1.683,1.271Z",
    transform: "translate(-34.32 -115.5)",
    fill: "#356f92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-13",
    transform: "translate(186.698 52.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510851",
    "data-name": "Path 510851",
    d: "M563.962,119.77a64.5,64.5,0,0,0-1.97,11.59l-.052,1.6s4,3.325,7.366,3.529l2.8-6.926Z",
    transform: "translate(-509.753 -104.176)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510852",
    "data-name": "Path 510852",
    d: "M583.564,113.249c-.767-3.313-1.063-7.166-3.813-9.324a10.047,10.047,0,0,0-6.966-1.938,9.129,9.129,0,0,0-3.833,1.271c-1.527.863-2.17,2.614-2.906,4.2-1.475,3.2-1.291,7.5-.292,8.7l13.321,7.03c2.658-1.383,4.324-1.934,4.748-5.479A13.03,13.03,0,0,0,583.564,113.249Z",
    transform: "translate(-511.574 -93.49)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510853",
    "data-name": "Path 510853",
    d: "M580.986,109.68l-8.393-2.47c-2.7-.4-4.632,2.874-4.912,5.6a48.411,48.411,0,0,0-.3,8.977c.544,4.564,4,5.28,4,5.28s0,.068-.02,1.415v2.8a2.3,2.3,0,0,0,.659,1.878c1.239,1.6,3.489,1.818,6.147.835a3.838,3.838,0,0,0,2.73-3.277l1.455-19.356A1.6,1.6,0,0,0,580.986,109.68Z",
    transform: "translate(-512.952 -96.616)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510854",
    "data-name": "Path 510854",
    d: "M570.319,130.813a.58.58,0,0,0,.54.607.552.552,0,0,0,.62-.5.58.58,0,0,0-.536-.607.556.556,0,0,0-.623.5Z",
    transform: "translate(-514.783 -110.502)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510855",
    "data-name": "Path 510855",
    d: "M569.707,127.225c.068.08.52-.232,1.147-.2s1.071.356,1.143.284-.032-.172-.228-.328a1.6,1.6,0,0,0-.911-.32,1.543,1.543,0,0,0-.919.256C569.743,127.054,569.671,127.193,569.707,127.225Z",
    transform: "translate(-514.41 -108.31)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510856",
    "data-name": "Path 510856",
    d: "M584.089,131.038a.584.584,0,0,0,.54.607.56.56,0,0,0,.62-.5.588.588,0,0,0-.54-.611.56.56,0,0,0-.62.5Z",
    transform: "translate(-523.05 -110.636)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510857",
    "data-name": "Path 510857",
    d: "M585.1,127.411c.072.08.524-.228,1.151-.2s1.071.36,1.143.284-.036-.172-.228-.324a1.6,1.6,0,0,0-.911-.32,1.515,1.515,0,0,0-.919.256C585.136,127.243,585.052,127.379,585.1,127.411Z",
    transform: "translate(-523.649 -108.423)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510858",
    "data-name": "Path 510858",
    d: "M576.661,130.6a4,4,0,0,0-1.007-.224c-.16-.024-.312-.06-.332-.172a.8.8,0,0,1,.124-.468c.164-.4.34-.779.52-1.2a24.189,24.189,0,0,0,1.2-3.141,22.73,22.73,0,0,0-1.435,3.038l-.5,1.2a.923.923,0,0,0-.108.623.4.4,0,0,0,.256.244,1.055,1.055,0,0,0,.268.048A4.072,4.072,0,0,0,576.661,130.6Z",
    transform: "translate(-517.656 -107.555)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510859",
    "data-name": "Path 510859",
    d: "M577.512,154.833a11.554,11.554,0,0,0,6.139-1.383s-1.627,3.117-6.151,2.514Z",
    transform: "translate(-519.094 -124.395)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510860",
    "data-name": "Path 510860",
    d: "M581.211,141.228a.9.9,0,0,0-.739-.44,1.175,1.175,0,0,0-1.1.488.739.739,0,0,0-.068.528c.036.092,0,.048.072.112a2.075,2.075,0,0,0,.827.556.875.875,0,0,0,.947-.308A.9.9,0,0,0,581.211,141.228Z",
    transform: "translate(-520.167 -116.789)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510861",
    "data-name": "Path 510861",
    d: "M580.759,139.75c-.1,0-.136.667-.735,1.123s-1.323.352-1.335.444.156.14.46.164a1.687,1.687,0,0,0,1.111-.332,1.479,1.479,0,0,0,.576-.947C580.875,139.922,580.811,139.75,580.759,139.75Z",
    transform: "translate(-519.808 -116.17)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510862",
    "data-name": "Path 510862",
    d: "M584.527,121.989c.044.176.675.156,1.4.316s1.295.4,1.407.272c.048-.068-.036-.236-.26-.424a2.486,2.486,0,0,0-2.138-.448C584.655,121.777,584.507,121.905,584.527,121.989Z",
    transform: "translate(-523.312 -105.292)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510863",
    "data-name": "Path 510863",
    d: "M569.808,122.6c.14.124.6-.092,1.171-.18s1.071-.06,1.163-.224c.036-.076-.06-.208-.292-.312a1.807,1.807,0,0,0-.987-.092,1.751,1.751,0,0,0-.891.4C569.788,122.385,569.745,122.541,569.808,122.6Z",
    transform: "translate(-514.46 -105.372)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510864",
    "data-name": "Path 510864",
    d: "M580.514,106l-.024.1h0Z",
    transform: "translate(-520.889 -95.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510865",
    "data-name": "Path 510865",
    d: "M577.282,127.41c.128-1.2-.352-2.4-.212-3.573.148-1.259.963-2.338,1.3-3.561.536-1.958-.2-4.041-.472-6.067a4.8,4.8,0,0,1-2.95-1.7,13.47,13.47,0,0,1-2-3.665,6.147,6.147,0,0,0,1.235,3.525,1.663,1.663,0,0,1-1.415-.46,3.681,3.681,0,0,1-.831-1.287,10.143,10.143,0,0,1-.8-3.629,13.064,13.064,0,0,0,.6,5.3,2.294,2.294,0,0,0-.987.04,1.087,1.087,0,0,1-.939-.2,1.172,1.172,0,0,1-.256-.6,13.588,13.588,0,0,1-.152-4.62,14.218,14.218,0,0,0-1.039,2.562,4.952,4.952,0,0,0,0,2.73.4.4,0,0,1-.563,0,.955.955,0,0,1-.248-.572,6.975,6.975,0,0,1,.152-2.3,11.541,11.541,0,0,0-.855,2.626,3.935,3.935,0,0,1-1.423,2.306,12.012,12.012,0,0,1,.112-3.481,10.369,10.369,0,0,1,1.023-2.762,8.17,8.17,0,0,1,1.838-2.562c1.335-1.171,1.894-.667,2.75-.22l.1.04v-.06l.036-.184a12.838,12.838,0,0,1,6.742.316c1.6.524,1.759,4,2.15,2.342.236-1,1.527-.084,1.543-.056,1.9,3.421,3.909,8.853,4,17.43h0Z",
    transform: "translate(-511.799 -95.141)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510866",
    "data-name": "Path 510866",
    d: "M599.747,93.91a4.28,4.28,0,0,0-2.95-1.435,3.221,3.221,0,0,0-2.85,1.483,2.594,2.594,0,0,0,.352,3.105l1.4,1.123a3.841,3.841,0,0,0,3.2.308,2.77,2.77,0,0,0,1.8-2.526A3.262,3.262,0,0,0,599.747,93.91Z",
    transform: "translate(-528.752 -87.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510867",
    "data-name": "Path 510867",
    d: "M598.585,106.051c-.272.124-1.039-1.051-2.4-1.974s-2.718-1.255-2.7-1.555c0-.136.4-.244,1.023-.18a5.248,5.248,0,0,1,3.893,2.686C598.677,105.591,598.709,105.991,598.585,106.051Z",
    transform: "translate(-528.693 -93.702)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510868",
    "data-name": "Path 510868",
    d: "M546.606,197.55l5.252-4.92,3.561,5.651c-.072.508-4.608,10.28-6.571,12.306-2.242,2.31-5.3,2.13-6.643-1.059a101.843,101.843,0,0,1-2.826-10.26Z",
    transform: "translate(-496.21 -147.916)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510869",
    "data-name": "Path 510869",
    d: "M559.855,166.719a16.081,16.081,0,0,0-4.98,3.065,7.744,7.744,0,0,0-1.059,1.639c-.659,1.447-1.906,12.166-1.906,12.166l5.6,4.049,4.872-18.745-.312-2.974Z",
    transform: "translate(-503.732 -131.881)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510870",
    "data-name": "Path 510870",
    d: "M565.263,195.651l.352-2.766a89.757,89.757,0,0,1-1.475-9.228,25.879,25.879,0,0,1,1.391-11.774c.14-.4,3.793-7.993,3.793-7.993s.767,2.33,3.849,1.779c4.3-.767,5.863-3.1,5.863-3.1l5.555,1.2s2.162,8.689,2.482,11.57c.168,1.543-1.862,10.268-1.862,10.268l3.273,4.9a47.919,47.919,0,0,1-1.719,7.194c-.3.256-5.627,1.515-5.691,1.743s-10.16,4.452-10.152,4.276-4.856-5.943-4.856-5.943Z",
    transform: "translate(-510.994 -129.87)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510871",
    "data-name": "Path 510871",
    d: "M563.066,188.47a1.115,1.115,0,0,1,0,.2c0,.152-.04.344-.068.572-.06.5-.144,1.223-.216,2.118a30.243,30.243,0,0,0,.128,6.986c.36,2.718.883,5.148,1.223,6.914.172.883.3,1.6.4,2.094.036.228.064.42.088.572a.8.8,0,0,1,0,.2.68.68,0,0,1-.056-.2c-.036-.152-.08-.34-.128-.564-.116-.524-.268-1.227-.452-2.082-.376-1.759-.923-4.185-1.283-6.914a28.141,28.141,0,0,1-.072-7.03c.092-.9.2-1.6.284-2.114.044-.248.08-.44.108-.568A.623.623,0,0,1,563.066,188.47Z",
    transform: "translate(-510.056 -145.418)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510872",
    "data-name": "Path 510872",
    d: "M587.554,239.574a75.12,75.12,0,0,1,4.153,11.463c4.033,15.072,7.446,35.343,8.581,39.476,1.511,5.5,4.892,17.957,6.611,26.25l-8.265,3.6s-10.823-29.176-13.777-36.338c-3.061-7.434-8.165-21.422-8.165-21.422l-2.95,55.554-7.918.244s-2.71-15.655-3.785-25.015-1.2-28.62-1.2-33.512c0-5.951,2.57-19.348,2.57-19.348s3.089,2.318,8.877,1.431c4.612-.707,14.176-4.253,14.176-4.253Z",
    transform: "translate(-509.093 -174.972)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510873",
    "data-name": "Path 510873",
    d: "M587.409,253.18a3.776,3.776,0,0,0,.044.639c.044.4.116,1,.212,1.731.2,1.459.5,3.465.891,5.675s.8,4.2,1.135,5.635c.16.719.3,1.3.4,1.695a4,4,0,0,0,.176.615,3.4,3.4,0,0,0-.1-.631c-.088-.44-.2-1.015-.34-1.707-.288-1.443-.675-3.433-1.071-5.643s-.719-4.209-.951-5.659c-.112-.7-.2-1.279-.276-1.723A4.535,4.535,0,0,0,587.409,253.18Z",
    transform: "translate(-525.043 -184.266)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510874",
    "data-name": "Path 510874",
    d: "M592.318,252.565s0-.1-.156-.16a1.019,1.019,0,0,0-.6-.02,1.2,1.2,0,0,0-.4.16.672.672,0,0,0-.268.44,1.011,1.011,0,0,0,.452,1.007,1.043,1.043,0,0,0,1.1.048.715.715,0,0,0,.3-.4,1.015,1.015,0,0,0,.032-.432.879.879,0,0,0-.268-.544c-.112-.092-.2-.1-.2-.092s.06.052.144.148a.883.883,0,0,1,.176.5.7.7,0,0,1-.288.663.879.879,0,0,1-.891-.06.835.835,0,0,1-.376-.8.5.5,0,0,1,.18-.332,1.2,1.2,0,0,1,.332-.16,1.112,1.112,0,0,1,.54-.044C592.262,252.509,592.3,252.577,592.318,252.565Z",
    transform: "translate(-527.126 -183.767)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510875",
    "data-name": "Path 510875",
    d: "M581.81,288.25a7.816,7.816,0,0,0,.955.655c.6.4,1.419.943,2.3,1.6s1.647,1.267,2.2,1.723a8.75,8.75,0,0,0,.907.723,5.223,5.223,0,0,0-.8-.831,27.1,27.1,0,0,0-2.174-1.783,25.94,25.94,0,0,0-2.342-1.547,5.338,5.338,0,0,0-1.043-.54Z",
    transform: "translate(-521.682 -205.319)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510876",
    "data-name": "Path 510876",
    d: "M632,359.584a.939.939,0,0,0,.34,0,9.18,9.18,0,0,0,.927-.072,16.567,16.567,0,0,0,5.839-1.831c.344-.184.62-.348.8-.468a1.234,1.234,0,0,0,.276-.2,10.713,10.713,0,0,0-1.147.544,21.578,21.578,0,0,1-2.83,1.119,21.322,21.322,0,0,1-2.962.7,12.448,12.448,0,0,0-1.243.216Z",
    transform: "translate(-551.812 -246.598)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510877",
    "data-name": "Path 510877",
    d: "M635.32,357.823a3.164,3.164,0,0,0,.8-.216c.492-.164,1.159-.42,1.883-.743a19.884,19.884,0,0,0,1.8-.915,3.248,3.248,0,0,0,.7-.464c-.032-.052-1.155.548-2.586,1.2S635.3,357.767,635.32,357.823Z",
    transform: "translate(-553.805 -245.68)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510878",
    "data-name": "Path 510878",
    d: "M560.267,425.21l-.04,8.249s-8.393,2.73-8.557,4.253l15.987.655.6-12.841Z",
    transform: "translate(-503.588 -287.54)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510879",
    "data-name": "Path 510879",
    d: "M584.331,444.615a.647.647,0,0,1,.42.763.627.627,0,0,1-.751.424.691.691,0,0,1-.444-.8.659.659,0,0,1,.835-.356",
    transform: "translate(-522.72 -299.184)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510880",
    "data-name": "Path 510880",
    d: "M567.648,455.969v-1.295l-15.339-.144s-.723.28-.663.8Z",
    transform: "translate(-503.571 -305.142)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510881",
    "data-name": "Path 510881",
    d: "M572.439,445.529c0,.08.4.132.759.4s.568.6.639.576-.024-.484-.484-.8S572.423,445.457,572.439,445.529Z",
    transform: "translate(-516.056 -299.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510882",
    "data-name": "Path 510882",
    d: "M568.17,447.146c0,.076.312.22.564.564s.312.691.4.691.144-.44-.176-.859S568.174,447.07,568.17,447.146Z",
    transform: "translate(-513.493 -300.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510883",
    "data-name": "Path 510883",
    d: "M564.71,450.051c.072.02.2-.364,0-.8s-.54-.623-.576-.56.18.3.324.663S564.634,450.043,564.71,450.051Z",
    transform: "translate(-511.068 -301.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510884",
    "data-name": "Path 510884",
    d: "M572.995,440.557c.032.072.4-.02.835.028s.775.2.8.136-.276-.356-.8-.4S572.951,440.5,572.995,440.557Z",
    transform: "translate(-516.387 -296.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510885",
    "data-name": "Path 510885",
    d: "M657.678,423.05l3.065,9.5,4.588,6.814a1.023,1.023,0,0,1-.336,1.455h0a1.019,1.019,0,0,1-.935.044c-1.918-.879-8.961-4.145-9.144-4.852-.216-.823-3.9-9.808-3.9-9.808Z",
    transform: "translate(-563.231 -286.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510886",
    "data-name": "Path 510886",
    d: "M670.523,459.328l-10.3-5.448.14.4a1.523,1.523,0,0,0,.671.823c.843.5,3.2,1.81,8.529,4.28A1.019,1.019,0,0,0,670.523,459.328Z",
    transform: "translate(-568.754 -304.751)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633203",
    "data-name": "Group 633203",
    transform: "translate(91.609 145.402)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510887",
    "data-name": "Path 510887",
    d: "M661.306,444.57a.62.62,0,0,1,.428.707.6.6,0,0,1-.7.428.652.652,0,0,1-.444-.751.616.616,0,0,1,.775-.364",
    transform: "translate(-660.577 -444.556)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510888",
    "data-name": "Path 510888",
    d: "M676.943,456.632a2.214,2.214,0,0,1,1.6-1.6c0-.024-.148-.056-.4,0a1.6,1.6,0,0,0-.8.444,1.575,1.575,0,0,0-.432.8A.813.813,0,0,0,676.943,456.632Z",
    transform: "translate(-578.77 -305.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510889",
    "data-name": "Path 510889",
    d: "M679.773,459.9c.06.028.256-.4.7-.7a8.1,8.1,0,0,1,.879-.44,1.135,1.135,0,0,0-1.007.264C679.857,459.388,679.717,459.9,679.773,459.9Z",
    transform: "translate(-580.485 -307.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510890",
    "data-name": "Path 510890",
    d: "M672.48,453.2a9.836,9.836,0,0,1,1-1.147,10.313,10.313,0,0,1,1.287-.8,2.8,2.8,0,0,0-2.282,1.958Z",
    transform: "translate(-576.114 -303.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510891",
    "data-name": "Path 510891",
    d: "M669.54,447.562c.044.048.492-.352,1.159-.612s1.263-.284,1.263-.348a1.963,1.963,0,0,0-1.343.144,2,2,0,0,0-1.079.815Z",
    transform: "translate(-574.349 -300.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510892",
    "data-name": "Path 510892",
    d: "M667.113,440.7a4.915,4.915,0,0,1,1.2-.667,5.12,5.12,0,0,1,1.359-.124c0-.024-.136-.1-.4-.156a2.179,2.179,0,0,0-1.027.068,2.206,2.206,0,0,0-.887.524C667.161,440.535,667.089,440.683,667.113,440.7Z",
    transform: "translate(-572.889 -296.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510893",
    "data-name": "Path 510893",
    d: "M666.863,436.278a.884.884,0,0,0-.112-.36,2.669,2.669,0,0,0-.608-.835,1.163,1.163,0,0,0-.651-.36.4.4,0,0,0-.4.24.652.652,0,0,0,0,.476,1.451,1.451,0,0,0,1.639.847A1.679,1.679,0,0,0,668,434.915a.568.568,0,0,0-.136-.464.4.4,0,0,0-.468-.064,1.463,1.463,0,0,0-.508.54,2.845,2.845,0,0,0-.4.955.848.848,0,0,0-.032.376,4.58,4.58,0,0,1,.547-1.247,1.391,1.391,0,0,1,.456-.46.216.216,0,0,1,.256.036.4.4,0,0,1,.068.308,1.483,1.483,0,0,1-1.111,1.175,1.255,1.255,0,0,1-1.4-.7.488.488,0,0,1,0-.336.224.224,0,0,1,.224-.136,1.067,1.067,0,0,1,.556.3A3.923,3.923,0,0,1,666.863,436.278Z",
    transform: "translate(-571.652 -293.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510894",
    "data-name": "Path 510894",
    d: "M536.771,188.47l3.813,3.937.156,3.433-4.428,1.019h-.224l-.288-2.214-2.55-3.393Z",
    transform: "translate(-492.53 -145.418)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510895",
    "data-name": "Path 510895",
    d: "M471.527,122.634A23.221,23.221,0,0,1,438.7,123.7h0a23.213,23.213,0,1,1,32.825-1.071Zm-31.762-.064a21.686,21.686,0,1,0-6.431-11.59A21.686,21.686,0,0,0,439.765,122.57Z",
    transform: "translate(-431.366 -82.432)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510896",
    "data-name": "Path 510896",
    d: "M471.527,122.634A23.221,23.221,0,0,1,438.7,123.7h0a23.213,23.213,0,1,1,32.825-1.071Zm-31.762-.064a21.686,21.686,0,1,0-6.431-11.59A21.686,21.686,0,0,0,439.765,122.57Z",
    transform: "translate(-431.366 -82.432)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510897",
    "data-name": "Path 510897",
    d: "M472.947,119.835a23.229,23.229,0,0,1-32.825,1.075h0a23.217,23.217,0,1,1,32.825-1.075Zm-31.762-.06a21.686,21.686,0,1,0-6.431-11.59,21.686,21.686,0,0,0,6.431,11.59Z",
    transform: "translate(-432.215 -80.752)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510898",
    "data-name": "Path 510898",
    d: "M554.106,206.331l.739-.715c.659-.635.292-2.094-.4-2.8L528.5,176l-3.469,3.357,25.907,26.778A2.3,2.3,0,0,0,554.106,206.331Z",
    transform: "translate(-487.595 -137.932)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510899",
    "data-name": "Path 510899",
    d: "M534.6,183.852a.619.619,0,0,0-.528-.14,1.043,1.043,0,0,0-.4.288,4.708,4.708,0,0,0-1.335,3.253,1.436,1.436,0,0,0,.6,1.339l.52-.3c.164-.208.643-.56.707-.8.272-1.075-.116-1.031.56-2.9a.644.644,0,0,0-.12-.743Z",
    transform: "translate(-491.984 -142.555)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510900",
    "data-name": "Path 510900",
    d: "M536.2,186.549a2.462,2.462,0,0,1,.516-.679.751.751,0,0,1,.687-.2c.36.112.536.627.492,1.111a4.124,4.124,0,0,1-.448,1.371c-.428.923-.851,1.85-1.279,2.778l-.248-.184a.356.356,0,0,1-.556-.12,1.435,1.435,0,0,1-.12-.759,7.266,7.266,0,0,1,.955-3.313Z",
    transform: "translate(-493.722 -143.725)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510901",
    "data-name": "Path 510901",
    d: "M538.282,191.508a6.523,6.523,0,0,1,1.283-1.719,1.6,1.6,0,0,1,.6-.452.564.564,0,0,1,.671.2.8.8,0,0,1-.092.683,31.694,31.694,0,0,1-2.206,3.873l-.767-.771C537.419,192.691,537.99,192.163,538.282,191.508Z",
    transform: "translate(-495.176 -145.914)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510902",
    "data-name": "Path 510902",
    d: "M570.642,207.883l-.7-.148-3.693-3.137-2-1.695a1.275,1.275,0,0,0-.591-.272l-2-.332a1.135,1.135,0,0,0,.6,1.367l1.1.568,1,1.2-.128.256s-6.551,1.019-6.962,1.519a.679.679,0,0,0,.184,1.043,1.055,1.055,0,0,0,.5.048,1.185,1.185,0,0,0,.635,1.407s-.727.955.544,1.411a2.038,2.038,0,0,0,1.091.951,47.155,47.155,0,0,0,5.044.683h4.7l.943.152Z",
    transform: "translate(-506.841 -153.721)",
    fill: "#ae7461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510903",
    "data-name": "Path 510903",
    d: "M558.85,217a5.136,5.136,0,0,0,1.815.1,7.306,7.306,0,0,0,1.79-.268,9.162,9.162,0,0,0-1.807.06A17.713,17.713,0,0,0,558.85,217Z",
    transform: "translate(-507.898 -162.432)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510904",
    "data-name": "Path 510904",
    d: "M560.82,220.7c0,.028.172.052.444.088s.651.088,1.075.116a8.965,8.965,0,0,0,1.087-.024,1.915,1.915,0,0,0,.448-.04c0-.028-.164-.088-.444-.108s-.663,0-1.079-.036-.8-.056-1.079-.052S560.82,220.667,560.82,220.7Z",
    transform: "translate(-509.081 -164.73)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510905",
    "data-name": "Path 510905",
    d: "M561.86,224.179a7.594,7.594,0,0,0,1.767.24,4.017,4.017,0,0,1,1.2.188c.292.108.424.264.448.24s-.08-.216-.4-.372a3.2,3.2,0,0,0-1.251-.264A7.994,7.994,0,0,0,561.86,224.179Z",
    transform: "translate(-509.705 -166.835)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510906",
    "data-name": "Path 510906",
    d: "M600.76,165.62s2.77.48,4.868,4.6c1.159,2.282,6.587,15.987,6.906,17.186,1.379,5.148-1.287,8.465-3.849,8.689-2.826.252-17.422-4.46-17.422-4.46l-.324-6.235,13.317,2.018L597.862,175S597.615,166.751,600.76,165.62Z",
    transform: "translate(-527.163 -131.701)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510907",
    "data-name": "Path 510907",
    d: "M628.316,223.611a2.29,2.29,0,0,0-.356-.831,5.568,5.568,0,0,0-1.5-1.6,5.479,5.479,0,0,0-2-.9,2.306,2.306,0,0,0-.9-.068c0,.036.344.06.867.212a6.243,6.243,0,0,1,1.91.923,6.342,6.342,0,0,1,1.495,1.5A6.738,6.738,0,0,0,628.316,223.611Z",
    transform: "translate(-546.746 -164.465)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510908",
    "data-name": "Path 510908",
    d: "M604.878,210.4h-.072l-.2-.044c-.18-.036-.436-.112-.767-.2-.667-.192-1.635-.492-2.854-.879-2.438-.779-5.887-1.914-9.936-3.285l-.06-.02V205.9c-.1-1.795-.2-3.749-.3-5.791v-.128l.128.024,3.273.528,10.032,1.639-.1.136c-1.81-3.545-3.337-6.539-4.424-8.657-.524-1.047-.943-1.878-1.239-2.462l-.32-.655a1.6,1.6,0,0,1-.1-.232,1.175,1.175,0,0,1,.132.22l.348.639c.3.58.739,1.4,1.287,2.438l4.488,8.625.084.164-.184-.028-10.044-1.6-3.277-.536.12-.1c.1,2.038.2,4,.292,5.791l-.068-.084,9.912,3.357,2.834.927c.332.1.584.188.755.232l.2.06Z",
    transform: "translate(-527.013 -146.517)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510909",
    "data-name": "Path 510909",
    d: "M611.332,166.25c0,.036-.376.264-.927.739a7.886,7.886,0,0,0-2.67,4.88c-.1.719-.072,1.179-.112,1.179a1.1,1.1,0,0,1-.044-.32,4.669,4.669,0,0,1,0-.875,6.765,6.765,0,0,1,.24-1.283,7.386,7.386,0,0,1,1.519-2.8,7.128,7.128,0,0,1,.943-.9,5.3,5.3,0,0,1,.731-.488A.983.983,0,0,1,611.332,166.25Z",
    transform: "translate(-537.139 -132.079)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-13",
    transform: "translate(104.511 53.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510910",
    "data-name": "Path 510910",
    d: "M228.54,187.27s-2.942,16.387-2.8,17.9.927,3.965,2.7,4.4a7.933,7.933,0,0,0,3.409,0l-2.13-20.1Z",
    transform: "translate(-225.734 -145.64)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510911",
    "data-name": "Path 510911",
    d: "M253.922,115.046l-.208-16.9c-.188-4.2,2.1-7.822,6.315-7.894h.4a7.53,7.53,0,0,1,7.214,7.226c.14,3.645.252,7.678.148,9.624-.216,4.037-4.28,4.5-4.28,4.5s-.024,2.458-.024,3.641l-3.269,4.508v.24Z",
    transform: "translate(-242.523 -87.396)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510912",
    "data-name": "Path 510912",
    d: "M270.406,141a9.764,9.764,0,0,1-5.2-1.771,5.028,5.028,0,0,0,5.2,2.89Z",
    transform: "translate(-249.431 -116.8)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510913",
    "data-name": "Path 510913",
    d: "M283.6,116.183a.58.58,0,0,1-.58.56.548.548,0,0,1-.572-.544.576.576,0,0,1,.576-.56.556.556,0,0,1,.576.544Z",
    transform: "translate(-259.781 -102.638)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510914",
    "data-name": "Path 510914",
    d: "M282.773,111.718c-.072.072-.5-.268-1.115-.292s-1.091.268-1.155.188.048-.168.252-.3a1.563,1.563,0,0,1,.927-.244,1.507,1.507,0,0,1,.887.328C282.753,111.546,282.813,111.686,282.773,111.718Z",
    transform: "translate(-258.601 -99.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510915",
    "data-name": "Path 510915",
    d: "M269.735,116.183a.58.58,0,0,1-.58.56.556.556,0,0,1-.576-.544.58.58,0,0,1,.58-.56.556.556,0,0,1,.576.544Z",
    transform: "translate(-251.454 -102.638)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510916",
    "data-name": "Path 510916",
    d: "M267.557,111.449c-.076.072-.5-.268-1.119-.292s-1.091.268-1.155.188.048-.168.252-.3a1.6,1.6,0,0,1,.927-.244,1.551,1.551,0,0,1,.887.328C267.529,111.277,267.589,111.417,267.557,111.449Z",
    transform: "translate(-249.464 -99.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510917",
    "data-name": "Path 510917",
    d: "M275.941,116.809a4,4,0,0,1,1.015-.14c.16,0,.312-.036.34-.144a.8.8,0,0,0-.084-.472c-.136-.4-.272-.8-.42-1.227a21.269,21.269,0,0,1-.923-3.2,21.074,21.074,0,0,1,1.179,3.113l.4,1.235a.931.931,0,0,1,.056.623.4.4,0,0,1-.272.22.967.967,0,0,1-.268.028A4.033,4.033,0,0,1,275.941,116.809Z",
    transform: "translate(-255.825 -100.231)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510918",
    "data-name": "Path 510918",
    d: "M267.428,106.519c-.092.156-.687-.036-1.419-.084s-1.347.044-1.415-.124c-.028-.08.1-.216.364-.336a2.4,2.4,0,0,1,1.1-.168,2.334,2.334,0,0,1,1.059.328C267.36,106.279,267.468,106.443,267.428,106.519Z",
    transform: "translate(-249.059 -96.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510919",
    "data-name": "Path 510919",
    d: "M282.726,107.12c-.132.136-.631-.024-1.239-.044s-1.127.064-1.239-.088c-.052-.072.032-.212.26-.34a2.022,2.022,0,0,1,1.019-.2,1.93,1.93,0,0,1,.983.312C282.718,106.9,282.786,107.064,282.726,107.12Z",
    transform: "translate(-258.45 -97.116)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510920",
    "data-name": "Path 510920",
    d: "M250.1,117.228c-.068-.036-2.742-.935-2.766,1.826a2.076,2.076,0,0,0,2.758,2.138C250.092,121.112,250.1,117.228,250.1,117.228Z",
    transform: "translate(-238.697 -103.491)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510921",
    "data-name": "Path 510921",
    d: "M250.307,121.469a.9.9,0,0,1-.132.068.476.476,0,0,1-.36,0,1.2,1.2,0,0,1-.54-1.075,1.535,1.535,0,0,1,.14-.687.559.559,0,0,1,.364-.364.248.248,0,0,1,.284.132c.036.08.02.132.032.14s.06-.048.04-.16a.312.312,0,0,0-.108-.176.344.344,0,0,0-.264-.072.675.675,0,0,0-.508.424,1.635,1.635,0,0,0-.176.767,1.228,1.228,0,0,0,.691,1.2.512.512,0,0,0,.444-.068C250.3,121.533,250.315,121.473,250.307,121.469Z",
    transform: "translate(-239.747 -104.818)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510922",
    "data-name": "Path 510922",
    d: "M271.054,125.55c.1,0,.1.627.647,1.075s1.219.376,1.223.464-.148.124-.436.136a1.6,1.6,0,0,1-1.023-.352,1.391,1.391,0,0,1-.484-.9C270.942,125.7,271.014,125.546,271.054,125.55Z",
    transform: "translate(-252.889 -108.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510923",
    "data-name": "Path 510923",
    d: "M266.973,89.552a.659.659,0,0,0-.3-.4,2,2,0,0,0-1.031-.18,5.863,5.863,0,0,1-2.522-.663,2.854,2.854,0,0,0,.751-.516,1.727,1.727,0,0,0,.516-1.719.4.4,0,0,0-.212-.268c-.18-.056-.34.12-.464.256a1.491,1.491,0,0,1-1.415.6,2.454,2.454,0,0,1-1.047-.32l-.032-.04-.436-.44h0a9.2,9.2,0,0,0-2.83-2.15,9.436,9.436,0,0,0-5.008-.452,3.8,3.8,0,0,0-2.9,2.922,2.926,2.926,0,0,0-2.93-.312h-.024a3.674,3.674,0,0,0-2.026,2.578l-.048.18a4.248,4.248,0,0,1-1.455,1.391c-.1.06-.224.132-.24.252a.356.356,0,0,0,.18.288,2.186,2.186,0,0,0,.863.368,4.8,4.8,0,0,1-.364.747c-.124.2-.268.448-.168.659a.452.452,0,0,0,.472.212,1.3,1.3,0,0,0,.5-.22c-.12.284-.244.572-.368.855a2.562,2.562,0,0,0,1.167-.064c.216,1.023.364,2.914.619,3.6a3.588,3.588,0,0,1,1.279.068c.48.164.288,1.011.911.775.32-.116.8-1.315.927-1.635a15.683,15.683,0,0,0,.759-6.671,5.1,5.1,0,0,1,1.579-1.115l-.048.044a4.6,4.6,0,0,1,3.485-.208c.823.4,1.3,1.291,1.918,2a5.8,5.8,0,0,0,4.245,2.122c.144,1.223.168,3.2.216,4.356l1-2.266h0a4.216,4.216,0,0,0,.208-.4l.024-.04h0a6.5,6.5,0,0,1,.328-.643h0a.711.711,0,0,0,1.047-.939,1.476,1.476,0,0,0-.34-.348,1.131,1.131,0,0,0,1.071.288.883.883,0,0,0,.632-.867.751.751,0,0,0-.44-.608,2.53,2.53,0,0,0,1.447-.3C266.773,90.176,267.064,89.912,266.973,89.552Z",
    transform: "translate(-236.29 -83.11)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510924",
    "data-name": "Path 510924",
    d: "M254.321,92a3.766,3.766,0,0,0-.4.368,2.882,2.882,0,0,0-.639,1.335,5.387,5.387,0,0,0-.112,1.027c0,.372.02.771.04,1.2a10.414,10.414,0,0,1,0,1.327,4.213,4.213,0,0,1-.1.7,1.435,1.435,0,0,1-.292.675.6.6,0,0,1-.572.184.879.879,0,0,1-.512-.3,2.082,2.082,0,0,1-.376-1.031h.084a3.321,3.321,0,0,1-.5.839,1.2,1.2,0,0,1-.8.4.775.775,0,0,1-.4-.076.7.7,0,0,1-.36-.643.5.5,0,0,1,.132-.312l.044.04a2.566,2.566,0,0,1-.879.639,2.8,2.8,0,0,1-.268.1.352.352,0,0,1-.1,0l.092-.036a2.711,2.711,0,0,0,.264-.116,2.606,2.606,0,0,0,.847-.651l.04.04a.52.52,0,0,0-.032.6.588.588,0,0,0,.252.252.707.707,0,0,0,.38.064,1.123,1.123,0,0,0,.735-.4,3.378,3.378,0,0,0,.48-.823l.06-.128.028.14a2,2,0,0,0,.36.987.8.8,0,0,0,.456.264.52.52,0,0,0,.488-.156,1.4,1.4,0,0,0,.272-.631,5.112,5.112,0,0,0,.1-.683,11.048,11.048,0,0,0,0-1.315c-.024-.424-.044-.823-.036-1.2a5.1,5.1,0,0,1,.128-1.039,2.85,2.85,0,0,1,.675-1.347,1.651,1.651,0,0,1,.428-.3Z",
    transform: "translate(-239.285 -88.447)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510925",
    "data-name": "Path 510925",
    d: "M276.031,92.723l-.032.024-.1.076a1.674,1.674,0,0,1-.172.108,2.369,2.369,0,0,1-.248.124,3.569,3.569,0,0,1-1.735.292,4.576,4.576,0,0,1-2.43-.927,8.022,8.022,0,0,1-2.07-2.442c-.288-.492-.52-1-.779-1.463a5.331,5.331,0,0,0-.891-1.243,2.77,2.77,0,0,0-1.155-.719,2.07,2.07,0,0,0-.616-.08,2.135,2.135,0,0,0-.564.1,2.33,2.33,0,0,0-.847.5,2.369,2.369,0,0,0-.464.588,2.99,2.99,0,0,0-.216.6.329.329,0,0,1,0-.04V88.1a1.9,1.9,0,0,1,.16-.456,2.231,2.231,0,0,1,.484-.6,2.342,2.342,0,0,1,.863-.524,2.258,2.258,0,0,1,.579-.112,2.075,2.075,0,0,1,.639.076,2.822,2.822,0,0,1,1.2.735,5.368,5.368,0,0,1,.907,1.259c.264.468.5.971.8,1.459a7.949,7.949,0,0,0,2.038,2.4,4.572,4.572,0,0,0,2.4.935,3.677,3.677,0,0,0,1.715-.26A5.85,5.85,0,0,0,276.031,92.723Z",
    transform: "translate(-248.53 -85.089)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510926",
    "data-name": "Path 510926",
    d: "M289.074,97.768a.711.711,0,0,1-.144.1,2.893,2.893,0,0,1-.432.212,4.072,4.072,0,0,1-.683.216,4.8,4.8,0,0,1-.871.108,4.647,4.647,0,0,1-.875-.072,4.063,4.063,0,0,1-.691-.188,2.522,2.522,0,0,1-.44-.2c-.1-.052-.152-.084-.148-.092s.228.1.611.224a5.033,5.033,0,0,0,.671.18,5.223,5.223,0,0,0,.855.06,5.035,5.035,0,0,0,.855-.1,5.324,5.324,0,0,0,.679-.192C288.87,97.88,289.066,97.752,289.074,97.768Z",
    transform: "translate(-261.185 -91.909)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510927",
    "data-name": "Path 510927",
    d: "M255.687,418.856l-.4,9.132s9.148,3.473,9.24,5.168l-17.737-.136.036-14.26Z",
    transform: "translate(-238.373 -284.61)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510928",
    "data-name": "Path 510928",
    d: "M253.561,439.83a.727.727,0,0,0-.508.823.7.7,0,0,0,.8.512.767.767,0,0,0,.532-.875.719.719,0,0,0-.9-.436",
    transform: "translate(-242.126 -297.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633204",
    "data-name": "Group 633204",
    transform: "translate(8.417 146.983)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510929",
    "data-name": "Path 510929",
    d: "M246.79,452.309l.06-1.439,16.986.671s.8.348.691.9Z",
    transform: "translate(-246.79 -450.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510930",
    "data-name": "Path 510930",
    d: "M266.33,441.54c0,.088-.436.124-.867.4s-.655.635-.735.6.052-.532.576-.855S266.35,441.46,266.33,441.54Z",
    transform: "translate(-249.128 -298.238)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510931",
    "data-name": "Path 510931",
    d: "M271.635,443.568c0,.084-.356.228-.655.6s-.4.747-.472.743-.136-.492.244-.939S271.635,443.489,271.635,443.568Z",
    transform: "translate(-252.579 -299.483)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510932",
    "data-name": "Path 510932",
    d: "M275.848,446.982c-.08,0-.2-.42.032-.891s.631-.655.667-.584-.216.324-.4.715S275.94,446.974,275.848,446.982Z",
    transform: "translate(-255.756 -300.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510933",
    "data-name": "Path 510933",
    d: "M265.646,435.992c-.036.076-.436-.044-.923,0s-.871.18-.919.108.328-.4.9-.4S265.69,435.924,265.646,435.992Z",
    transform: "translate(-248.584 -294.78)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510934",
    "data-name": "Path 510934",
    d: "M268.694,436.17a14.666,14.666,0,0,1,.024,2.2l-.072-.108c1.035.4,2.4.923,3.877,1.6a20.932,20.932,0,0,1,3.933,2.262,4.235,4.235,0,0,1,.971.991c.184.288.16.5.132.492a1.251,1.251,0,0,0-.228-.424,4.8,4.8,0,0,0-1-.891,26.024,26.024,0,0,0-3.929-2.162c-1.455-.683-2.818-1.239-3.833-1.675l-.076-.032v-.076a14.567,14.567,0,0,1,.2-2.174Z",
    transform: "translate(-251.4 -295.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510935",
    "data-name": "Path 510935",
    d: "M240.34,259.65v8.277l3.269,26.438s-1.035,12.39-1.675,19.4c-.552,6.079.352,16.662.352,16.662h9.684l3.461-35.3,2.15-22.014,3.9-13.041Z",
    transform: "translate(-234.501 -189.092)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510936",
    "data-name": "Path 510936",
    d: "M265.328,411.764l-2.514,8.769s8.077,5.527,7.766,7.194l-17.21-4.3,3.389-13.853Z",
    transform: "translate(-242.323 -279.093)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510937",
    "data-name": "Path 510937",
    d: "M263.067,431.84a.727.727,0,0,0-.687.683.691.691,0,0,0,.667.683.759.759,0,0,0,.723-.723.715.715,0,0,0-.771-.635",
    transform: "translate(-247.732 -292.462)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633205",
    "data-name": "Group 633205",
    transform: "translate(11.027 142.967)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510938",
    "data-name": "Path 510938",
    d: "M253.32,442.2l.4-1.383,16.355,4.644s.683.524.46,1.043Z",
    transform: "translate(-253.32 -440.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510939",
    "data-name": "Path 510939",
    d: "M274.991,436.71c-.024.08-.452,0-.935.18s-.8.468-.859.4.18-.508.763-.7S275.027,436.634,274.991,436.71Z",
    transform: "translate(-254.22 -295.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510940",
    "data-name": "Path 510940",
    d: "M279.588,439.891c0,.088-.4.14-.775.424s-.552.639-.635.616,0-.516.456-.859S279.6,439.807,279.588,439.891Z",
    transform: "translate(-257.198 -297.252)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510941",
    "data-name": "Path 510941",
    d: "M282.929,444.065c-.08,0-.092-.452.24-.855s.767-.492.8-.4-.288.264-.556.6S283,444.093,282.929,444.065Z",
    transform: "translate(-260.04 -299.028)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510942",
    "data-name": "Path 510942",
    d: "M275.869,430.99c-.056.068-.4-.148-.9-.232s-.891-.032-.915-.112.4-.3.971-.184S275.925,430.934,275.869,430.99Z",
    transform: "translate(-254.742 -291.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510943",
    "data-name": "Path 510943",
    d: "M273.3,261.06l.444,4.5-.536,32.693-7.662,26.266-1.858,6.371-9.892-1.862,7.626-67.964Z",
    transform: "translate(-242.581 -189.938)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510944",
    "data-name": "Path 510944",
    d: "M272.848,312.794a.542.542,0,0,1-.036.156c-.036.1-.072.256-.124.452-.116.4-.284,1-.5,1.759l-1.9,6.6c-1.639,5.655-3.957,13.645-6.671,23.005l-.024.076h-.076l-9.892-1.858h-.088v-.092c.5-2.666,1.031-5.448,1.571-8.289,1.6-8.393,3.1-16.343,4.42-23.273v.028c-1.639-10.284-2.946-18.481-3.7-23.181h0l-1.651-3.006-.4-.779c-.1-.172-.14-.264-.14-.264s.056.084.156.256l.44.767,1.683,2.99h0c.767,4.7,2.106,12.9,3.785,23.181v.028c-1.307,6.934-2.8,14.868-4.4,23.281-.536,2.838-1.067,5.623-1.571,8.289l-.072-.108,9.888,1.866-.1.06c2.742-9.348,5.08-17.33,6.734-22.981.831-2.818,1.495-5.052,1.946-6.591.228-.759.4-1.347.528-1.751l.136-.448C272.828,312.854,272.848,312.794,272.848,312.794Z",
    transform: "translate(-242.425 -203.788)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510945",
    "data-name": "Path 510945",
    d: "M290.07,267.77a2.922,2.922,0,0,1-.536.8,7.43,7.43,0,0,1-1.759,1.5,7.139,7.139,0,0,1-2.138.871,2.978,2.978,0,0,1-.947.116,8.9,8.9,0,0,0,5.38-3.277Z",
    transform: "translate(-261.125 -193.967)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510946",
    "data-name": "Path 510946",
    d: "M343.512,143.4a.4.4,0,0,0-.1-.576.192.192,0,0,0-.148-.044,5.689,5.689,0,0,1-1.119.42c-.4.02-1.083-.116-1.487.256a12.093,12.093,0,0,0-1.5,2.858c-.124.46-.56,4.34-.56,4.34Z",
    transform: "translate(-293.489 -118.929)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510947",
    "data-name": "Path 510947",
    d: "M344.125,143.05c-.02.024-4.8,2.134-6.9,3.061a.707.707,0,0,0-.2,1.167h0a.743.743,0,0,0,.851.136l6.858-3.341.568-.859Z",
    transform: "translate(-292.407 -119.094)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510948",
    "data-name": "Path 510948",
    d: "M338.748,147.315l1.523-1.123,2-2.918s.823-.492,1.251-.18.568.663.368,1.063c0,0,1.139.272,1.219.651a4.4,4.4,0,0,1-.164,1.307,2.294,2.294,0,0,1,0,1.087,1.75,1.75,0,0,0-.144.7,2.089,2.089,0,0,1,.4,1.823,11.367,11.367,0,0,1-2.354,3.509,15.247,15.247,0,0,1-2.054,1.167l-.879,1.842-3.641-3.3Z",
    transform: "translate(-292.09 -119.058)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510949",
    "data-name": "Path 510949",
    d: "M346.642,144a.8.8,0,0,1-.092.16l-.272.4c-.232.348-.556.823-.919,1.347l-.512.739a1.937,1.937,0,0,1-.264.3,1.127,1.127,0,0,1-.292.188,2.247,2.247,0,0,1-.472.16.7.7,0,0,1-.18.032,1.625,1.625,0,0,1,.172-.06,2.823,2.823,0,0,0,.456-.176c.4-.168.655-.715,1.031-1.223s.7-1,.939-1.335l.288-.4a1.2,1.2,0,0,1,.116-.132Z",
    transform: "translate(-296.515 -119.664)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510950",
    "data-name": "Path 510950",
    d: "M352.32,148.218a12.17,12.17,0,0,1,.588-1.147,11.816,11.816,0,0,1,.651-1.111,22.615,22.615,0,0,1-1.239,2.258Z",
    transform: "translate(-301.726 -120.841)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510951",
    "data-name": "Path 510951",
    d: "M352.277,155.219a.373.373,0,0,0-.052-.16.7.7,0,0,0-.24-.3.656.656,0,0,0-.368-.116h-.168a.324.324,0,0,1,.168-.052.62.62,0,0,1,.4.108.628.628,0,0,1,.244.348C352.3,155.151,352.285,155.223,352.277,155.219Z",
    transform: "translate(-301.203 -126.019)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510952",
    "data-name": "Path 510952",
    d: "M356.16,156.832a.816.816,0,0,1-.148-.1,1.825,1.825,0,0,0-.356-.232.675.675,0,0,0-.4-.064c-.1.02-.14.084-.152.076s0-.088.136-.128a.647.647,0,0,1,.448.048,1.2,1.2,0,0,1,.36.264C356.124,156.772,356.168,156.824,356.16,156.832Z",
    transform: "translate(-303.395 -127.084)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510953",
    "data-name": "Path 510953",
    d: "M356.12,151.965a3.077,3.077,0,0,1,.336-.6,3.147,3.147,0,0,1,.4-.56,6.066,6.066,0,0,1-.735,1.155Z",
    transform: "translate(-304.007 -123.752)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510954",
    "data-name": "Path 510954",
    d: "M347.693,153.067a.473.473,0,0,0-.036-.156.58.58,0,0,0-.208-.3.615.615,0,0,0-.344-.1h-.156a.281.281,0,0,1,.152-.06.54.54,0,0,1,.607.44C347.725,153.019,347.7,153.067,347.693,153.067Z",
    transform: "translate(-298.502 -124.734)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510955",
    "data-name": "Path 510955",
    d: "M338.186,152.22a.832.832,0,0,0,.132-.192.676.676,0,0,0,.036-.532.691.691,0,0,0-.38-.376c-.132-.056-.224-.052-.224-.064a.348.348,0,0,1,.244,0,.679.679,0,0,1,.428.4.659.659,0,0,1-.06.584C338.278,152.188,338.19,152.22,338.186,152.22Z",
    transform: "translate(-292.979 -123.887)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510956",
    "data-name": "Path 510956",
    d: "M294.515,168.591l5.783,4.948,7.094-10.6L312,165.662s-6.914,15.915-8.793,17.322-3.453,1.039-5.867-.072-10.995-9.76-10.995-9.76Z",
    transform: "translate(-262.122 -131.034)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510957",
    "data-name": "Path 510957",
    d: "M321.388,193.748c-.056,0,.1-1.007.032-2.242s-.328-2.21-.272-2.226A7.614,7.614,0,0,1,321.388,193.748Z",
    transform: "translate(-283.008 -146.847)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510958",
    "data-name": "Path 510958",
    d: "M234.539,156.6s4.912.072,4.984,6.195a102.474,102.474,0,0,1-1.251,14.316L225.73,174.9s1.555-11.4,2.886-14.684S232.5,156.043,234.539,156.6Z",
    transform: "translate(-225.73 -127.135)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510959",
    "data-name": "Path 510959",
    d: "M242.5,145.8l-.156,1s-6.7,4.428-7.082,5.571c-.588,1.771.7,16.742,1.259,20.987s.679,13.589.679,13.589a13.308,13.308,0,0,0-1.031,3.633,4.444,4.444,0,0,0,1.031,2.914c7.194,2.346,15.987.544,25.483-1.623l-.092-2.694-3.105-29.268s.907-7.594-2.8-9.808c-.4-.244-3.645-2.082-3.645-2.082Z",
    transform: "translate(-231.363 -120.744)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633206",
    "data-name": "Group 633206",
    transform: "translate(21.918 37.741)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510960",
    "data-name": "Path 510960",
    d: "M280.57,177.54a22.673,22.673,0,0,0,2.206,9.029,26.741,26.741,0,0,0,5.639,7.826l-1.007-8.757Z",
    transform: "translate(-280.57 -177.54)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510961",
    "data-name": "Path 510961",
    d: "M284.619,157.485c-1.175-.951-3.361-1.471-4.608-.615a3.729,3.729,0,0,0-1.511,1.862,14.074,14.074,0,0,0,.424,8.945c.851,2.486,4.964,7.266,4.964,7.266l10.172-6.171s-6.794-8.249-7.518-9.1A17.865,17.865,0,0,0,284.619,157.485Z",
    transform: "translate(-257.073 -127.129)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510962",
    "data-name": "Path 510962",
    d: "M284.529,157.421a1.556,1.556,0,0,1,.216.172,6.913,6.913,0,0,1,.56.568c.472.52,1.091,1.327,1.93,2.314l6.794,8.177.06.076-.08.052-9.592,5.839-.556.34-.068.04-.052-.06c-1.139-1.343-2.194-2.694-3.141-4.053a21.184,21.184,0,0,1-1.3-2.07,8.5,8.5,0,0,1-.5-1.079c-.136-.368-.248-.735-.352-1.1a13.35,13.35,0,0,1-.1-7.965,3.745,3.745,0,0,1,2.118-2.186,3.473,3.473,0,0,1,1.267-.148,4.461,4.461,0,0,1,1.051.18,5.165,5.165,0,0,1,1.347.592,2.536,2.536,0,0,1,.4.312,3.89,3.89,0,0,0-.428-.28,5.392,5.392,0,0,0-1.347-.556,4.612,4.612,0,0,0-1.039-.16,3.381,3.381,0,0,0-3.253,2.286,13.312,13.312,0,0,0,.136,7.878c.108.36.22.727.356,1.087a7.87,7.87,0,0,0,.492,1.055,21.325,21.325,0,0,0,1.291,2.05c.943,1.351,2,2.7,3.133,4.037l-.12-.02.56-.34,9.616-5.823-.02.124-6.746-8.221c-.827-1-1.439-1.818-1.894-2.342a6.774,6.774,0,0,0-.54-.584A1.45,1.45,0,0,1,284.529,157.421Z",
    transform: "translate(-256.983 -127.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510963",
    "data-name": "Path 510963",
    d: "M235.153,170.72a.572.572,0,0,1,.028.176c0,.14.028.308.048.512.036.472.08,1.107.136,1.882.1,1.6.24,3.793.4,6.2s.324,4.616.468,6.2c.072.771.132,1.4.176,1.874a4.9,4.9,0,0,0,.044.512.881.881,0,0,1,0,.18.671.671,0,0,1-.044-.176c-.02-.136-.044-.3-.076-.5-.068-.444-.148-1.083-.236-1.874-.176-1.6-.364-3.773-.524-6.2s-.268-4.62-.34-6.211c-.032-.771-.056-1.407-.076-1.882V170.9A.636.636,0,0,1,235.153,170.72Z",
    transform: "translate(-231.384 -135.705)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510964",
    "data-name": "Path 510964",
    d: "M262.556,259.649a1.144,1.144,0,0,1-.188.056l-.548.136c-.24.056-.532.12-.875.184s-.731.14-1.167.208c-.863.148-1.9.268-3.053.38s-2.43.168-3.769.188-2.614-.04-3.773-.116-2.2-.2-3.061-.34c-.436-.056-.827-.132-1.167-.2s-.639-.12-.875-.18l-.552-.132a.68.68,0,0,1-.188-.06,1.2,1.2,0,0,1,.2.024l.556.1c.24.048.536.1.879.148s.735.12,1.167.172c.867.124,1.9.212,3.057.3s2.422.108,3.757.1,2.606-.084,3.757-.168,2.186-.212,3.049-.344c.436-.056.827-.12,1.167-.18s.639-.1.879-.152l.556-.1A.66.66,0,0,1,262.556,259.649Z",
    transform: "translate(-236.302 -189.091)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-13",
    transform: "translate(38.218 61.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510965",
    "data-name": "Path 510965",
    d: "M91.734,102.66a5.34,5.34,0,0,0-4.065,1.015,5.16,5.16,0,0,0-1.854,2.318,3.553,3.553,0,0,0,.136,2.918,4.52,4.52,0,0,0,2.4,1.886,5.144,5.144,0,0,0,2.55.4,2.914,2.914,0,0,0,2.146-1.319l1.663-3.513a3.629,3.629,0,0,0-2.974-3.7Z",
    transform: "translate(-75.293 -102.593)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510966",
    "data-name": "Path 510966",
    d: "M114.475,108.242h0a9.412,9.412,0,0,0-12.106-2.4,13.676,13.676,0,0,0-1.2.8,9.924,9.924,0,0,0-3.865,8.449,11.107,11.107,0,0,0,4.58,8.177l12.646-3.081a25.947,25.947,0,0,0,1.387-6.794,9.316,9.316,0,0,0,.032-1A6.91,6.91,0,0,0,114.475,108.242Z",
    transform: "translate(-82.33 -103.799)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510967",
    "data-name": "Path 510967",
    d: "M104.982,117.652a4.688,4.688,0,0,1,3.529-4.32l6.327-1.6c2.738-.3,4.56,3.069,4.74,5.811a43.492,43.492,0,0,1-.032,8.545c-.719,4.576-4.225,5.168-4.225,5.168v3.513l.068,5.815-9.009-6.475-1.411-16.387C104.982,117.628,104.982,117.756,104.982,117.652Z",
    transform: "translate(-86.942 -108.069)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510968",
    "data-name": "Path 510968",
    d: "M137.655,134.7a.588.588,0,0,1-.568.612.564.564,0,0,1-.607-.528.588.588,0,0,1,.564-.6A.564.564,0,0,1,137.655,134.7Z",
    transform: "translate(-105.858 -121.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510969",
    "data-name": "Path 510969",
    d: "M136.074,130.075c-.076.076-.52-.252-1.151-.248s-1.1.32-1.163.24.04-.172.244-.32a1.627,1.627,0,0,1,.927-.288,1.527,1.527,0,0,1,.915.292C136.042,129.892,136.106,130.031,136.074,130.075Z",
    transform: "translate(-104.213 -118.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510970",
    "data-name": "Path 510970",
    d: "M124.031,134.675a.592.592,0,0,1-.568.6.564.564,0,0,1-.6-.528.588.588,0,0,1,.564-.6.564.564,0,0,1,.608.528Z",
    transform: "translate(-97.682 -121.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510971",
    "data-name": "Path 510971",
    d: "M121.38,130.351c-.072.076-.52-.252-1.151-.248s-1.091.32-1.159.244.04-.172.24-.32a1.6,1.6,0,0,1,.931-.288,1.547,1.547,0,0,1,.915.292C121.348,130.18,121.428,130.319,121.38,130.351Z",
    transform: "translate(-95.394 -118.89)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510972",
    "data-name": "Path 510972",
    d: "M129.289,135.278a4.184,4.184,0,0,1,1.023-.188c.164,0,.316-.048.344-.16a.819.819,0,0,0-.112-.476l-.48-1.227a22.288,22.288,0,0,1-1.075-3.2,22.391,22.391,0,0,1,1.331,3.113c.164.432.316.839.46,1.235a.927.927,0,0,1,.088.631.4.4,0,0,1-.268.236,1.016,1.016,0,0,1-.272.04,4.108,4.108,0,0,1-1.039-.008Z",
    transform: "translate(-101.357 -119.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510973",
    "data-name": "Path 510973",
    d: "M115.7,156.49s1.487,3.145,6.067,2.706v-1.075a11.534,11.534,0,0,1-6.067-1.631Z",
    transform: "translate(-93.384 -134.949)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510974",
    "data-name": "Path 510974",
    d: "M119.985,124.3c-.06.172-.691.092-1.431.184s-1.339.292-1.439.14c-.044-.076.06-.236.3-.4a2.47,2.47,0,0,1,1.067-.376,2.4,2.4,0,0,1,1.123.132C119.861,124.1,120.013,124.231,119.985,124.3Z",
    transform: "translate(-94.227 -115.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510975",
    "data-name": "Path 510975",
    d: "M134.683,124.293c-.108.144-.544,0-1.067,0s-.967.1-1.067-.052c-.048-.072.024-.216.216-.352a1.539,1.539,0,0,1,1.723.048C134.671,124.077,134.719,124.225,134.683,124.293Z",
    transform: "translate(-103.489 -115.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510976",
    "data-name": "Path 510976",
    d: "M102.87,134.5a1.6,1.6,0,0,0-2.47,1.543,1.845,1.845,0,0,0,2.462,1.91C102.866,137.864,102.87,134.5,102.87,134.5Z",
    transform: "translate(-84.198 -121.598)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510977",
    "data-name": "Path 510977",
    d: "M103.037,138.21a.7.7,0,0,1-.116.064.432.432,0,0,1-.32,0,1.067,1.067,0,0,1-.484-.959,1.4,1.4,0,0,1,.128-.615.488.488,0,0,1,.324-.324.212.212,0,0,1,.252.12c.032.068,0,.116.032.12s.052-.04.032-.14a.248.248,0,0,0-.1-.156.308.308,0,0,0-.236-.064.592.592,0,0,0-.452.376,1.475,1.475,0,0,0-.156.687,1.107,1.107,0,0,0,.615,1.067.464.464,0,0,0,.4-.06C103.033,138.27,103.045,138.214,103.037,138.21Z",
    transform: "translate(-85.125 -122.799)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510978",
    "data-name": "Path 510978",
    d: "M103.1,142.218a.484.484,0,0,0-.236.939.5.5,0,0,0,.6-.284.508.508,0,0,0-.248-.619",
    transform: "translate(-85.455 -126.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510979",
    "data-name": "Path 510979",
    d: "M103.162,142.252a.7.7,0,0,1,.22.332.4.4,0,0,1-.1.4.464.464,0,0,1-.46.132.456.456,0,0,1-.3-.372.4.4,0,0,1,.144-.372.652.652,0,0,1,.372-.144.245.245,0,0,0-.116-.028.54.54,0,0,0-.308.108.492.492,0,0,0-.2.444.528.528,0,0,0,.939.3.492.492,0,0,0,.1-.476.52.52,0,0,0-.192-.268.212.212,0,0,0-.108-.056Z",
    transform: "translate(-85.413 -126.37)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510980",
    "data-name": "Path 510980",
    d: "M123.592,145.194a.911.911,0,0,1,.739-.444,1.2,1.2,0,0,1,1.1.492.735.735,0,0,1,.068.528c-.036.092,0,.048-.072.112a2.107,2.107,0,0,1-.823.556.887.887,0,0,1-.951-.308A.9.9,0,0,1,123.592,145.194Z",
    transform: "translate(-98.058 -127.897)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510981",
    "data-name": "Path 510981",
    d: "M123.865,143.72c.1,0,.136.667.739,1.123s1.323.348,1.331.444-.156.14-.46.16a1.7,1.7,0,0,1-1.111-.328,1.479,1.479,0,0,1-.576-.947C123.745,143.888,123.813,143.716,123.865,143.72Z",
    transform: "translate(-98.231 -127.283)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510982",
    "data-name": "Path 510982",
    d: "M114,110.159a1.019,1.019,0,0,0-.823-.4,13.085,13.085,0,0,0-11.59,5l.7,4.261c-.3.528,1.1,1.6,1.707,1.559a1.643,1.643,0,0,0,1.3-1.139c.424-1.111.18-2.538,1.051-3.349a3.776,3.776,0,0,1,1.85-.715,9.532,9.532,0,0,0,3.505-1.483A6.135,6.135,0,0,0,114,110.9.939.939,0,0,0,114,110.159Z",
    transform: "translate(-84.913 -106.859)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510983",
    "data-name": "Path 510983",
    d: "M98.143,122.47a2.062,2.062,0,0,1-.24-.448,8.322,8.322,0,0,1-.468-1.3A9.572,9.572,0,0,1,99.3,112.1a8.394,8.394,0,0,1,.963-1,2.17,2.17,0,0,1,.4-.308c.028.032-.54.48-1.251,1.391a9.908,9.908,0,0,0-1.835,8.493C97.859,121.815,98.179,122.47,98.143,122.47Z",
    transform: "translate(-82.217 -107.52)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510984",
    "data-name": "Path 510984",
    d: "M107.42,420.955l1.451,12.51,5.479-.835.372-12.33Z",
    transform: "translate(-88.413 -293.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510985",
    "data-name": "Path 510985",
    d: "M113.136,444.94s-3.681,3.121-5.731.827l-.1-.372-1.914,10.188a1.131,1.131,0,0,0,.715,1.3,1.047,1.047,0,0,0,1.111-.312c1.487-1.675,6.934-8.149,6.934-8.149l-.216-1.631a5.408,5.408,0,0,0-.8-1.854Z",
    transform: "translate(-87.179 -308.114)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510986",
    "data-name": "Path 510986",
    d: "M115.382,450.61l-7.682,9.72a1.063,1.063,0,0,0,.951-.352c4.113-4.684,6.9-8.149,6.9-8.149Z",
    transform: "translate(-88.581 -311.517)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510987",
    "data-name": "Path 510987",
    d: "M109.626,461.172a3.2,3.2,0,0,0-.967-.763,3.241,3.241,0,0,0-1.2-.148c0-.024.116-.116.356-.168a1.6,1.6,0,0,1,.947.1,1.683,1.683,0,0,1,.743.6C109.626,461,109.674,461.16,109.626,461.172Z",
    transform: "translate(-88.437 -317.192)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510988",
    "data-name": "Path 510988",
    d: "M108.288,465.521a8.228,8.228,0,0,0-.951-.4,8.075,8.075,0,0,0-1.027-.06,1.167,1.167,0,0,1,1.075-.16C108.013,465.037,108.344,465.485,108.288,465.521Z",
    transform: "translate(-87.746 -320.058)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510989",
    "data-name": "Path 510989",
    d: "M111.5,456.358a10.55,10.55,0,0,0-1.431-.7,13.866,13.866,0,0,0-1.567-.256,2.318,2.318,0,0,1,1.639.032,2.4,2.4,0,0,1,1.359.927Z",
    transform: "translate(-89.061 -314.312)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510990",
    "data-name": "Path 510990",
    d: "M111.911,451.015c-.024.068-.615-.136-1.367-.108s-1.331.256-1.355.192a2.6,2.6,0,0,1,2.722-.084Z",
    transform: "translate(-89.474 -311.547)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510991",
    "data-name": "Path 510991",
    d: "M159.845,437.1c-.124-.192-1.275-4.4-1.275-4.4l7.1-1.93,1.007,6.031Z",
    transform: "translate(-119.12 -299.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510992",
    "data-name": "Path 510992",
    d: "M167.166,441.47l.24,1.067s7.81,3.2,7.909,4.732l-15.435.112.192-5.687C162.374,442.8,164.528,442.605,167.166,441.47Z",
    transform: "translate(-119.906 -306.03)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510993",
    "data-name": "Path 510993",
    d: "M159.88,454.3l.048-1.3,14.788.368s.691.308.615.819Z",
    transform: "translate(-119.906 -312.952)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510994",
    "data-name": "Path 510994",
    d: "M176.745,444.136c0,.08-.38.12-.751.376s-.564.592-.631.56.04-.488.492-.8S176.761,444.064,176.745,444.136Z",
    transform: "translate(-129.189 -307.585)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510995",
    "data-name": "Path 510995",
    d: "M181.379,445.947c0,.076-.308.216-.564.552s-.324.691-.4.687-.124-.448.2-.863S181.375,445.863,181.379,445.947Z",
    transform: "translate(-132.201 -308.697)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510996",
    "data-name": "Path 510996",
    d: "M185.1,449.019c-.068,0-.176-.376,0-.8s.544-.611.576-.548-.184.3-.336.659S185.172,448.995,185.1,449.019Z",
    transform: "translate(-134.987 -309.746)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510997",
    "data-name": "Path 510997",
    d: "M129.427,255.087s3.917,17.558,7.23,37.809c2.722,16.654,3.929,34.683,3.929,34.683l-8.021.472s-4.884-20.655-8.693-35.5a191.121,191.121,0,0,0-6.363-20.875l-1.6-18.073Z",
    transform: "translate(-93.51 -193.247)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510998",
    "data-name": "Path 510998",
    d: "M84.64,248.57s-7.034,9.508-6.443,19.436c.356,5.935,12.39,58.7,12.39,58.7l7.122-.24-2.274-56.05,2.4-18.349Z",
    transform: "translate(-70.848 -190.227)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510999",
    "data-name": "Path 510999",
    d: "M147.174,184.55a1.416,1.416,0,0,1,.036.292c0,.22.036.5.064.847.056.739.1,1.807.12,3.125.048,2.642-.076,6.291-.34,10.308s-.492,7.654-.54,10.292c-.032,1.315-.04,2.4-.032,3.121v.847a1.252,1.252,0,0,1,0,.3,1.6,1.6,0,0,1-.028-.3c0-.22-.028-.5-.044-.851-.036-.735-.052-1.807-.044-3.125,0-2.642.212-6.283.476-10.3s.4-7.654.4-10.288c0-1.319,0-2.4-.048-3.125v-.847A1.391,1.391,0,0,1,147.174,184.55Z",
    transform: "translate(-111.793 -151.794)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511000",
    "data-name": "Path 511000",
    d: "M193.873,185.757l-4.288,1.575-4.684,6.343,1.279,2.218,1.263-1.2s4.824-.9,5.172-1.6a1.331,1.331,0,0,0-.048-1.275,2.958,2.958,0,0,0,.036-1.339.871.871,0,0,0-.6-.667.663.663,0,0,0,.3-.891,1.171,1.171,0,0,0-.7-.8,20.046,20.046,0,0,0,3.133-1.755.32.32,0,0,0-.028-.4A.719.719,0,0,0,193.873,185.757Z",
    transform: "translate(-134.926 -152.486)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511001",
    "data-name": "Path 511001",
    d: "M183.06,193.731l.863-1.2,1.87-3.393L189.962,188s.7.328-.268,1.571a2.51,2.51,0,0,1-2.326.991s.3,2.706-.44,3.917-2.726,1.311-2.726,1.311Z",
    transform: "translate(-133.822 -153.865)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511002",
    "data-name": "Path 511002",
    d: "M192.86,194.691a1.019,1.019,0,0,0,.184-.268,3.91,3.91,0,0,0,.34-.823,4.636,4.636,0,0,0-.116-2.958l-.064.124.148-.024a5.2,5.2,0,0,0,1.575-.46,2.086,2.086,0,0,0,.951-.987,1.551,1.551,0,0,0,.132-.935.759.759,0,0,0-.124-.32,2.093,2.093,0,0,1,.06.332,1.6,1.6,0,0,1-.176.867,2,2,0,0,1-.911.9,5.263,5.263,0,0,1-1.535.432l-.148.024h-.1l.04.1a4.768,4.768,0,0,1,.16,2.854A9.458,9.458,0,0,1,192.86,194.691Z",
    transform: "translate(-139.705 -153.889)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511003",
    "data-name": "Path 511003",
    d: "M198.245,196.39a4.4,4.4,0,0,0-.428.156c-.272.1-.671.232-1.163.42a4.4,4.4,0,0,0-.775.4.843.843,0,0,0-.348.4.635.635,0,0,0,.084.568.971.971,0,0,0,.436.376.955.955,0,0,0,.587.036q.14-.028.276-.048a2.4,2.4,0,0,0,.292-.068c.188-.056.376-.124.56-.2l.5-.2-.056-.168a4.3,4.3,0,0,0-.951.54l-.42.288a4.112,4.112,0,0,0-.4.276.607.607,0,0,0-.236.464.432.432,0,0,0,.088.26.531.531,0,0,0,.2.144,1.846,1.846,0,0,0,.8.108,3.821,3.821,0,0,0,1.079-.288,1.656,1.656,0,0,0,.364-.18,2.217,2.217,0,0,0-.4.116,4.116,4.116,0,0,1-1.067.228,1.738,1.738,0,0,1-.723-.116.292.292,0,0,1-.2-.272.464.464,0,0,1,.188-.34c.112-.1.26-.164.4-.26l.428-.284a4.18,4.18,0,0,1,.911-.516l-.056-.168-.52.164c-.184.072-.368.14-.548.192a1.731,1.731,0,0,1-.268.064,1.366,1.366,0,0,0-.284.052.8.8,0,0,1-.492-.02.851.851,0,0,1-.372-.308.488.488,0,0,1-.072-.424.715.715,0,0,1,.284-.324,4.521,4.521,0,0,1,.747-.4c.476-.2.875-.352,1.139-.472A1.47,1.47,0,0,0,198.245,196.39Z",
    transform: "translate(-141.289 -158.902)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511004",
    "data-name": "Path 511004",
    d: "M197.555,191.9a2.994,2.994,0,0,0-.883.308,6.6,6.6,0,0,0-.9.512c-.16.108-.324.232-.488.364a.9.9,0,0,0-.4.588.476.476,0,0,0,.148.372.644.644,0,0,0,.324.156,2,2,0,0,0,.619,0,7.1,7.1,0,0,0,1-.216,2.71,2.71,0,0,0,.871-.348c0-.024-.344.1-.9.228a9.4,9.4,0,0,1-.987.172,2.079,2.079,0,0,1-.568,0,.376.376,0,0,1-.336-.348.8.8,0,0,1,.336-.464c.16-.132.316-.252.472-.364a8.087,8.087,0,0,1,.859-.532C197.227,192.052,197.563,191.94,197.555,191.9Z",
    transform: "translate(-140.922 -156.206)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511005",
    "data-name": "Path 511005",
    d: "M148.924,185.594l-4.3-13.793a3.961,3.961,0,0,0-2.574-2.626l-2.63-.6,2.91,22.382.651,1.683c1.535,3.425,4.9,2.846,7.866,1.331a2.9,2.9,0,0,0,.312-.168l8.681-6.994-2.874-5.172Z",
    transform: "translate(-107.623 -142.207)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511006",
    "data-name": "Path 511006",
    d: "M160.758,215.141c.056,0,.072-.919.364-2s.727-1.874.683-1.9a4.912,4.912,0,0,0-.847,1.854A5.128,5.128,0,0,0,160.758,215.141Z",
    transform: "translate(-120.416 -167.817)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511007",
    "data-name": "Path 511007",
    d: "M95.67,172.552l2.906,27.13,16.1,1.2,1.283-1.1-.448-20.483-5.783-14.592h0a3.415,3.415,0,0,1-3.6,1.627,5.955,5.955,0,0,1-3-1.139l-2.658-1.914Z",
    transform: "translate(-81.359 -139.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511008",
    "data-name": "Path 511008",
    d: "M87.461,163.24,85.5,165.374l-9.216,2.206,5.392,26.075-4.089,10.092a25.371,25.371,0,0,0-1.075,3.265l-2.53,9.9s8.709,2.37,10.951,1.075,4.984-13.885,5.815-16.87,2.074-11.874,1.491-16.606-2.054-10.04-2.554-12.446S87.461,163.24,87.461,163.24Z",
    transform: "translate(-68.338 -139.001)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511009",
    "data-name": "Path 511009",
    d: "M69.47,197.013l2.074-8.057L67.807,174.1s-1.747,1.243-2.906,5.8c-1.2,4.776-5.276,17.921-5.028,20.995s16.486,8.645,16.486,8.645l.663-8.549Z",
    transform: "translate(-59.863 -145.521)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511010",
    "data-name": "Path 511010",
    d: "M130.88,162.11l1.271,1.966,5.288,1.335a88.914,88.914,0,0,1,1.391,8.881c0,1.91-.8,23.077-.8,24.072s3.821,14.532,3.489,15.359-4.316,1.415-4.316,1.415-1.479-11.71-1.479-15.7-.172-13.8-1-18.593-3.821-16.786-3.821-16.786Z",
    transform: "translate(-102.497 -138.323)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511011",
    "data-name": "Path 511011",
    d: "M137.71,204.605a.46.46,0,0,1,0-.1V203.1c.024-.991.056-2.4.092-4.113.084-3.469.224-8.265.308-13.561v-1.958c0-.643-.068-1.271-.116-1.894-.1-1.247-.2-2.446-.316-3.6s-.248-2.222-.4-3.225a14.073,14.073,0,0,0-.775-2.71,35.744,35.744,0,0,0-1.739-3.713l-.536-.983-.14-.256c-.032-.056-.044-.088-.04-.088a.34.34,0,0,1,.06.08l.156.244c.136.216.332.54.572.963a31.277,31.277,0,0,1,1.807,3.7,13.852,13.852,0,0,1,.8,2.734c.18,1.011.316,2.094.44,3.237s.224,2.342.328,3.6c.048.619.12,1.255.12,1.906v1.966c-.084,5.3-.248,10.092-.368,13.561-.068,1.723-.124,3.121-.16,4.109-.024.472-.044.847-.056,1.119a1.213,1.213,0,0,1-.02.288A.4.4,0,0,1,137.71,204.605Z",
    transform: "translate(-104.398 -141.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511012",
    "data-name": "Path 511012",
    d: "M108.245,198.353a1.474,1.474,0,0,1-.048-.3c0-.2-.048-.484-.072-.859-.048-.747-.1-1.834-.072-3.177,0-.667.04-1.4.092-2.19a9.592,9.592,0,0,0-.312-2.466,40.89,40.89,0,0,0-1.91-5.456c-.8-1.894-1.627-3.673-2.4-5.284a21.325,21.325,0,0,1-1.023-2.326,20.138,20.138,0,0,1-.54-2.134c-.268-1.319-.4-2.4-.508-3.141-.044-.372-.076-.663-.092-.859a2.4,2.4,0,0,1,0-.3,1.5,1.5,0,0,1,.06.3q.048.324.132.851c.12.739.288,1.814.572,3.121a20.437,20.437,0,0,0,.56,2.114,21.683,21.683,0,0,0,1.035,2.3c.775,1.6,1.6,3.389,2.4,5.288a38.7,38.7,0,0,1,1.906,5.475,9.652,9.652,0,0,1,.3,2.518c-.06.8-.1,1.515-.12,2.182-.04,1.339,0,2.422,0,3.169q.024.54.036.863A1.706,1.706,0,0,1,108.245,198.353Z",
    transform: "translate(-84.774 -142.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511013",
    "data-name": "Path 511013",
    d: "M139.7,231.394l-4.532,6.123a.827.827,0,0,1-.8.324l-19.608-3.7a.827.827,0,0,1-.631-1.071l2.114-6.511a.823.823,0,0,1,.935-.556l22.026,4.089a.827.827,0,0,1,.5,1.307Z",
    transform: "translate(-92.415 -176.668)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511014",
    "data-name": "Path 511014",
    d: "M72.47,231.148a1.906,1.906,0,0,1,.659-.532,4.025,4.025,0,0,1,3.957-.056,1.91,1.91,0,0,1,.675.516c-.024.028-.28-.168-.743-.4a4.352,4.352,0,0,0-3.821.052C72.742,230.972,72.49,231.176,72.47,231.148Z",
    transform: "translate(-67.431 -179.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633207",
    "data-name": "Group 633207",
    transform: "translate(9.679 61.36)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511015",
    "data-name": "Path 511015",
    d: "M84.08,258.41l7.746,2.846.807-3.213,3.669.739.492-1.854-5.755-.807-.06,2.662-6.019-2.27Z",
    transform: "translate(-84.08 -256.12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_511016",
    "data-name": "Path 511016",
    d: "M101.956,238.807s1.547-1.311,2.026-1.6,2.1-1.363,2.842-1.251l.739.108-.663,1.958s5.939-.887,6.75.072-.883,1.143-1.771,1.255-3.733.592-3.733.592,7.422-.8,7.937,0-.719,1-.719,1l-4.916,1.954-.564.224-.564.735s-2,1.4-2.646,1.219-5.2-1.051-5.2-1.051Z",
    transform: "translate(-84.847 -182.651)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511017",
    "data-name": "Path 511017",
    d: "M115.58,249.726a5.554,5.554,0,0,1,1.151-.352,28.009,28.009,0,0,1,2.85-.544,27.51,27.51,0,0,1,2.89-.26,6.3,6.3,0,0,1,1.2.02,7.6,7.6,0,0,1-1.2.132c-.739.06-1.755.16-2.874.316s-2.122.34-2.846.484A8.028,8.028,0,0,1,115.58,249.726Z",
    transform: "translate(-93.311 -190.216)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511018",
    "data-name": "Path 511018",
    d: "M117.26,254.2a3.03,3.03,0,0,1,1.067-.4,3.09,3.09,0,0,1,1.115-.18,3.122,3.122,0,0,1-1.063.4,3.069,3.069,0,0,1-1.119.18Z",
    transform: "translate(-94.32 -193.257)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511019",
    "data-name": "Path 511019",
    d: "M149.32,185.32a1.2,1.2,0,0,1,.036.272c0,.2.032.46.056.8.052.679.088,1.667.112,2.886.044,2.442-.068,5.811-.312,9.524s-.468,7.054-.5,9.492c-.028,1.2-.036,2.2-.028,2.882v.8a1.287,1.287,0,0,1,0,.272,1.312,1.312,0,0,1-.028-.272c0-.2-.024-.46-.04-.8-.036-.683-.048-1.671-.04-2.89,0-2.438.2-5.807.44-9.52s.4-7.07.372-9.508c0-1.2,0-2.2-.044-2.882v-.8A1.082,1.082,0,0,1,149.32,185.32Z",
    transform: "translate(-113.119 -152.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511020",
    "data-name": "Path 511020",
    d: "M85.239,189.257a2.478,2.478,0,0,1-.036-.544c0-.352-.024-.859-.068-1.487a25.026,25.026,0,0,0-2.522-9.392c-.272-.564-.508-1.015-.679-1.323a2.8,2.8,0,0,1-.244-.492,2.426,2.426,0,0,1,.316.452c.192.292.448.735.743,1.295a22.978,22.978,0,0,1,1.783,4.588,22.549,22.549,0,0,1,.751,4.848c.024.631.024,1.143,0,1.495a2.475,2.475,0,0,1-.044.56Z",
    transform: "translate(-72.966 -146.673)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBooks);
export default __webpack_public_path__ + "static/media/EmptyBooks.5e56bd4785bda74f19364ef72e648ed8.svg";
export { ForwardRef as ReactComponent };